{
  "settings" : {
    "calendar" : {
      "calendar_settings" : "Paramètres du calendrier",
      "settings" : "Paramètres",
      "select_calendar_type" : "Sélectionne le type de calendrier",
      "add_new_calendar_group" : "Ajouter un nouveau groupe de calendrier",
      "add_new_equipment" : "Ajoute un nouvel équipement",
      "new_calendar" : "Nouveau calendrier",
      "calendar_group_description" : "Utilise des groupes de calendriers pour organiser et regrouper efficacement plusieurs calendriers.",
      "group" : "Groupe",
      "manage_your_calendars_and_groups" : "Gérer vos calendriers et vos groupes",
      "groups" : "Groupes",
      "create_group" : "Créer un groupe",
      "create_calendar" : "Créer un calendrier",
      "calendar_name" : "Nom du calendrier",
      "group_duration" : "Durée du groupe",
      "calendar_type" : "Type",
      "action" : "Action",
      "round_robin" : "Tour de table",
      "event" : "Événement",
      "group_name" : "Nom du groupe",
      "room_name" : "Nom de la salle",
      "group_description" : "Description du groupe",
      "calendar_url" : "URL du calendrier",
      "calendars" : "Calendriers",
      "date_updated" : "Date de mise à jour",
      "status" : "Statut",
      "action_dropdown" : "Liste déroulante d’action",
      "calendar_list" : "Services associés à",
      "edit" : "Modifier",
      "duplicate" : "Dupliquer",
      "copy_embed_code" : "Copier le code d'intégration",
      "copy_permanent_link" : "Copie le lien permanent",
      "copy_new_slug_link" : "Copier le lien de planification",
      "copy_scheduling_link" : "Copier le lien de planification (héritage obsolète)",
      "deactivate_calendar" : "Désactiver le calendrier",
      "move_to_group" : "Déplacer vers le groupe",
      "delete_calendar" : "Supprimer le calendrier",
      "delete_group" : "Supprimer",
      "delete_this_group" : "Supprime ce groupe",
      "activate_calendar" : "Active le calendrier",
      "duration" : "Durée",
      "all" : "Tous",
      "draft" : "Ébauche",
      "inactive" : "Inactif",
      "active" : "Actif",
      "actions" : "activités",
      "rearrange_calendars" : "Réorganiser les calendriers",
      "deactivate_all_calendars_in_group" : "Suspendre les calendriers in groupe",
      "activate_all_calendars_in_group" : "Active tous les calendriers dans le groupe",
      "no_groups_found" : "Votre recherche ne correspondait à aucun groupe de calendrier.",
      "no_groups_in_location" : "Groupe de tri de vos calendriers J’comme le dossier. Ajoutez des calendriers à un groupe et partagez un lien individuel pour la programmation, ce qui permet d'enregistrer plusieurs calendriers.",
      "no_calendars_found" : "Commence à utiliser le calendrier en créant un nouveau calendrier.",
      "no_calendars_found_search" : "Votre recherche ne correspondait à aucun calendrier.",
      "delete_calendar_message" : "Vous êtes sur le point de supprimer le calendrier. Lorsque vous cliquez sur supprimer, tous les rendez-vous sont également supprimés.",
      "delete_calendar_message_title" : "Supprimer ce calendrier?",
      "duplicate_calendar_message" : "Vous êtes sur le point de dupliquer le calendrier. Cela créera un nouveau calendrier avec les mêmes paramètres que le calendrier sélectionné.",
      "duplicate_calendar_message_title" : "Dupliquer ce calendrier ?",
      "no_calendars_found_title" : "Aucun calendrier trouvé",
      "no_groups_in_location_title" : "Aucun groupe trouvé",
      "delete_group_confirmation_title" : "Supprimer ce groupe ?",
      "delete_group_confirmation" : "Es-tu sûr de vouloir supprimer le groupe sélectionné?",
      "delete_group_confirmation_checkbox_title" : "Supprime les calendriers et les rendez-vous associés",
      "delete_group_confirmation_checkbox_description" : "En sélectionnant cette option, tu supprimeras également les calendriers de ce groupe, ainsi que tous les rendez-vous de ces calendriers.",
      "group_status_message_title" : "{status}",
      "calendar_status_message_title" : "{status} ce calendrier ?",
      "calendar_status_message" : "Vous êtes sur le point de {status} Calendrier",
      "group_status_active_message" : "Êtes-vous sûr de vouloir créer ce groupe ? Tous les calendriers au sein du groupe seront également activés et disponibles pour la réservation",
      "group_status_inactive_message" : "Voulez-vous vraiment Suspendre ce groupe? Tous les calendriers au sein du groupe seront également Handicapés et disponibles pour la réservation",
      "coming_soon" : "Bientôt disponible",
      "select" : "Sélectionner",
      "15mins" : "15 min",
      "cancel" : "Annuler",
      "save" : "Enregistrer",
      "create" : "Créer",
      "select_calendar_group" : "Sélectionner Groupe de calendrier",
      "move_calendar_confirmation" : "Veuillez noter que le lien hérité cessera de fonctionner une fois que vous aurez procédé au changement. Veuillez confirmer en cochant la case.",
      "previously_called_unassigned" : " (Précédemment appelé non attribué)",
      "scheduling_type" : "Type",
      "scheduling_type_description" : "Sélectionnez un Type de .",
      "service_menu_name" : "Nom du menu de service",
      "template" : "Modèle",
      "select_template" : "Sélectionnez un modèle.",
      "group_url" : "URL du groupe",
      "template_description" : "Vous avez maintenant le choix de sélectionner les modèles Classic ou Neo pour la vue Groupe",
      "rooms" : "Pièces",
      "rooms_name" : "Nom",
      "rooms_description" : "Description",
      "rooms_modal_description" : "Ajouter ou modifier une salle",
      "rooms_capacity" : "Capacité totale",
      "no_rooms_in_location_title" : "Aucune pièce trouvée",
      "no_rooms_in_location" : "Aucune chambre n'a été trouvée à cet endroit",
      "no_equipments_in_location" : "Aucun équipement trouvé à cet endroit",
      "equipments" : "Équipement",
      "equipment_name" : "Nom",
      "equipment_name_search" : "Nom de l’équipement",
      "equipment_description" : "Description",
      "equipment_modal_description" : "Ajouter ou modifier un équipement",
      "add_equipment" : "Ajouter/modifier de l'équipement",
      "add_room" : "Ajouter/Modifier une salle",
      "equipment_quantity" : "Quantité totale",
      "equipment_outOfService" : "Quantité hors service",
      "no_equipments_in_location_title" : "Aucun équipement trouvé",
      "delete_this_equipment" : "Supprime cet équipement",
      "delete_this_rooms" : "Supprime cette salle",
      "delete_equipment_confirmation" : "Êtes-vous sûr de vouloir supprimer cet équipement ? Elle sera également supprimée de tous les calendriers liés.",
      "delete_rooms_confirmation" : "Êtes-vous sûr de vouloir supprimer cette pièce ? Elle sera également supprimée de tous les calendriers liés.",
      "add_new_calendar_equipments" : "Ajouter un nouvel équipement",
      "no_equipments_found" : "Votre recherche ne correspondait à aucun équipement.",
      "no_rooms_found" : "Votre recherche ne correspond à aucune pièce.",
      "add_new_calendar_rooms" : "Ajouter une nouvelle pièce",
      "rooms_disable" : "Désactiver la pièce",
      "equipments_disable" : "Désactiver l'équipement",
      "equipments_activate" : "Activer l’équipement",
      "rooms_activate" : "Activer la pièce",
      "create_equipments" : "Créer de l’équipement",
      "create_rooms" : "Créer une pièce",
      "select_calendar_rooms_title" : "Sélectionne le calendrier",
      "select_calendar_rooms_description" : "Tu peux sélectionner plusieurs calendriers à associer à des pièces",
      "select_calendar_equipments_title" : "Sélectionne le calendrier",
      "select_calendar_equipments_description" : "Vous pouvez sélectionner un calendrier à associer à l’équipement",
      "disable_equipment_title" : "{status} équipement",
      "disable_room_title" : "{status} pièce",
      "equipments_status_message" : "Êtes-vous sûr de vouloir {status} cet équipement?",
      "rooms_status_message" : "Êtes-vous sûr de vouloir {status} cette pièce?",
      "calendar_resource_disclaimer" : "Cela pourrait affecter la disponibilité sur les calendriers de service associés.",
      "equipment_disclaimer" : "Remarque : Activer l'équipement plus tard le reconnectera automatiquement aux calendriers auxquels il est associé",
      "room_disclaimer" : "Remarque : l'activation de la pièce plus tard reconnectera automatiquement la salle aux calendriers auxquels elle est associée",
      "equipment_tab_name" : "Équipement",
      "rooms_tab_name" : "Pièces",
      "manage_your_rooms" : "Gérez les pièces pour votre entreprise ici",
      "manage_your_equipments" : "Gérez l’équipement pour votre entreprise ici",
      "select_service_calendar_description_equipments" : "Vous pouvez sélectionner plusieurs calendriers de service à associer à l'équipement",
      "select_service_calendar_description_rooms" : "Vous pouvez sélectionner plusieurs calendriers de service à associer à des pièces",
      "service_menus" : "Menu de services",
      "manage_your_calendars_groups_and_service_menus" : "Gérer vos calendriers, groupes et menu de service",
      "new_service_menu" : "Créer un menu de service",
      "deactivate_service_menu" : "Désactiver le menu de service",
      "delete_service_menu" : "Supprimer ce menu de service",
      "delete_service_menu_confirmation" : "Etes-vous sûr de vouloir supprimer ce menu de service?",
      "service_menu_status_message_title" : "{status} ce menu de service?",
      "service_menu_status_message" : "Vous êtes sur le point de {status} le menu de service",
      "no_service_menus_in_location_title" : "Créez votre menu de service personnalisé",
      "add_new_service_menu" : "Ajouter un nouveau menu de service",
      "no_service_menus_in_location" : "Commencez par créer un nouveau menu de services et ajoutez-y des groupes.",
      "no_service_menu_found" : "Aucun menu de service trouvé",
      "no_service_menu_found_desc" : "Votre recherche ne correspondait à aucun menu de service.",
      "apply" : "Appliquer",
      "troubleshoot_calendar" : "Dépanner le calendrier",
      "round_robin_booking" : "Tour de table",
      "round_robin_description" : "Planifie les réunions entre les membres de l'équipe dans un ordre rotatif.",
      "round_robin_example" : "Par exemple : les appels de vente, les sessions de recrutement.",
      "unassigned_booking" : "Calendrier des événements",
      "unassigned_description" : "Pour planifier des événements physiques sans la présence d'un hôte.",
      "unassigned_example" : "Par exemple : les conférences, les séminaires publics, les expositions.",
      "event_booking_alert_title" : "Important",
      "event_booking_alert_message" : "Ce type de calendrier présente des différences majeures",
      "event_booking_know_more" : "En savoir plus",
      "event_booking_tooltip_title" : "Ce qu'il faut savoir :",
      "event_booking_tooltip_content" : "• Les outils de lien de réunion dynamiques ne sont pas pris en charge (par exemple, Zoom/Google Meet/MS Teams)\n• Aucun utilisateur ne peut être attribué\n• Les événements ne sont pas synchronisés avec le calendrier d'un utilisateur par défaut\n• Un seul calendrier Google peut être synchronisé via la synchronisation externe\n• Les calendriers conflictuels ne sont pas pris en charge.",
      "class_booking" : "Réservation de cours",
      "class_booking_description" : "Un hôte rencontre plusieurs participants.",
      "class_booking_example" : "Par exemple : les webinaires, les formations de groupe, les cours en ligne.",
      "collective_booking" : "Réservation collective",
      "collective_booking_description" : "Plusieurs hôtes rencontrent le même participant.",
      "collective_booking_example" : "Par exemple : les entretiens avec un groupe, les examens par des comités.",
      "service_booking" : "Réservation professionnelle",
      "service_booking_description" : "Planification fluide pour les entreprises de prestation de services.",
      "service_booking_example" : "Par exemple : les rendez-vous au spa, les services de réparation, les consultations.",
      "personal_booking" : "Réservation personnelle",
      "personal_booking_description" : "Planifie des réunions individuelles avec un membre spécifique de l’équipe.",
      "personal_booking_example" : "Ex. : les réunions avec des clients, les consultations privées.",
      "personal" : "Personnel",
      "explore_more_types" : "Découvrez davantage de formats",
      "no_calendars_added" : "Aucun calendrier pour le moment - Collection un seul!",
      "no_calendars_added_description" : "Créez votre premier calendrier pour commencer la calendrier sans effort.",
      "no_groups_added" : "Aucun groupe encore - Début par vous organiser!",
      "no_calendars_yet" : "Aucun calendrier pour le moment",
      "no_groups_yet" : "Aucun groupe pour le moment",
      "no_calendars_access" : "Aucun calendrier n’a été créé pour le moment. Une fois un calendrier créé, il apparaîtra ici. Vous n'avez pas accès pour créer un calendrier, veuillez Contact votre administrateur si nécessaire.",
      "no_groups_access" : "Aucun groupe n’a encore été configuré. Une fois qu'un groupe est créé, il apparaîtra ici. Vous n'avez pas accès pour créer un groupe, veuillez Contact votre administrateur si nécessaire.",
      "no_groups_added_description" : "Utilisez Groupe pour organiser vos calendriers. Ajoutez des calendriers à un groupe et partagez un lien de groupe individuel pour la réservation.",
      "group_success_message" : "Le groupe est créé avec succès. Vous pouvez maintenant inclure des calendriers à ce groupe.",
      "choose_calendars" : "Sélectionner des calendriers",
      "do_it_later" : "Je le faire plus tard",
      "add_calendars_to_group" : "Ajouter des calendriers au Groupe",
      "select_calendars_to_add" : "Veuillez sélectionner tous les calendriers que vous souhaitez inclure dans le {name}",
      "add_calendars" : "Ajouter un ou plusieurs calendriers",
      "continue" : "Continuer",
      "conflicting_calendars" : "Calendriers des conflits",
      "conflicting_calendars_description" : "Les calendriers Traînant faites déjà partie du groupe Autres. Voulez-vous les Déplacer vers votre nouveau groupe, <b>{name}</b>?",
      "group_associated_with" : "Groupe Actuel",
      "move_calendar_consent" : "Ignorer ces calendriers pour le nouveau groupe.",
      "calendars_moved_successfully" : "Tous les calendriers sélectionnés ont été déplacés avec succès vers {name}.",
      "new_group" : "Nouveau Groupe",
      "back" : "Retour",
      "share_otl" : "Partagez vos Date avec un lien unique qui expire après une réservation, garantissant l'accès.",
      "copied_to_clipboard" : "Copié dans le presse-papiers",
      "generate_link" : "Générer un nouveau lien",
      "generate_link_error" : "Impossible de générer un lien unique. Veuillez réessayer.",
      "share_schedule_link" : " Le lien de programmation est déterminé par le Limace. Modifier le Limace, et le Lien de programmation s'adaptera automatiquement à la modification.",
      "share_permanent_link" : "Idéal pour les entonnoirs, les redirections de Site Web Web, les publicités, le lien permanent reste constant et n'est pas affecté via Limace dynamique.",
      "copy" : "Copie",
      "share_embed_code" : "Placez ce Code in votre HTML à {embedType} l'endroit où vous souhaitez que votre Widget apparaisse.",
      "scheduling_link" : "Lien de programmation",
      "permanent_link" : "Lien permanent",
      "one_time_link" : "Lien à une Date",
      "embed_code" : "Code d'intégration",
      "loading" : "Chargement…",
      "share_group" : "Partager le Groupe",
      "edit_group" : "Modifier le Groupe",
      "more_options" : "Plus d’options",
      "share_calendar" : "Partager le calendrier",
      "edit_calendar" : "Modifier le calendrier",
      "troubleshoot_calendar_link" : "Dépannage le calendrier",
      "calendar_config_success" : "Vous avez configuré avec succès votre calendrier individuel/groupe",
      "close" : " Fermer",
      "added_calendars" : "Calendrier(s) ajouté(s)",
      "select_calendars" : "Sélectionner un ou plusieurs calendriers",
      "settings_confirmation" : "Pour poursuivre, veuillez confirmer ces dynamiques.",
      "consent_checkbox_title" : "Je comprends et acceptez ces dynamiques",
      "confirm" : "Confirme",
      "create_group_access_disabled" : "Vous n'avez pas l'autorisation de créer un groupe. Contact votre administrateur pour l'accès.",
      "create_calendar_access_disabled" : "Vous n'avez pas l'autorisation de créer un calendrier. Contact votre administrateur pour l'accès.",
      "preview_booking_widget" : "Widget de réservation’ Voir un aperçu",
      "share_service_menu" : "Partager le menu de service",
      "back_message" : "Retour à la Liste des calendriers",
      "service_calendars" : "Calendriers des services",
      "owned_by" : "Propriétaire via",
      "owned_by_anyone" : "Tout le monde",
      "owned_by_me" : "Envoyez un message",
      "all_groups" : "Tout le groupe",
      "all_calendars" : "Tous les calendriers",
      "not_grouped" : "Non regroupé",
      "delete_group_desc" : "Voulez-vous vraiment supprimer ce groupe ? Cela supprimera également tous les calendriers des membres de ce groupe.",
      "calendar_listing_title" : "Référencement dans le calendrier",
      "calendar_group_name" : "Calendrier/ Nom du Groupe",
      "success" : "Succès",
      "my_calendar" : "mon-calendrier"
    },
    "preferences" : {
      "preferences" : "Préférences",
      "my_preferences" : "Ma préférence",
      "account_preferences" : "Préférence de compte",
      "user_preferences" : "Préférences de l’utilisateur",
      "set_preferences" : "Définissez vos préférences pour votre compte.",
      "scheduling_options" : "Options de planification",
      "meeting_location" : "Lieu de réunion",
      "zoom" : "Zoom",
      "save_preferences" : "Enregistrer tes préférences",
      "in_app_preferences" : "Dans les préférences de l'application",
      "set_start_day" : "Définir des préférences telles que le jour de début de l'application",
      "view_options" : "Afficher les options",
      "services" : "Services",
      "feature_toggle_aria" : "Bascule de caractéristiques",
      "week_starts_on" : "La semaine commence le",
      "sunday" : "Dimanche",
      "widget_preferences" : "Préférences de widget",
      "set_widget_language" : "Définir les préférences comme la langue du widget",
      "language_and_region" : "Langue et région",
      "language" : "Langue",
      "english" : "Anglais",
      "time_format" : "Format de l'heure",
      "time_format_value" : "1:30 PM",
      "monday" : "Lundi",
      "custom_meeting_location" : "Lieu de réunion personnalisé",
      "view_appointments_in_1" : "Voir les rendez-vous dans",
      "timezone_uses_details_1" : "Nous utiliserons ce fuseau horaire pour afficher les heures de rendez-vous dans l’application et dans vos courriels liés aux rendez-vous — juste pour vous. Cela n’affectera pas votre disponibilité ni la façon dont les autres réservent auprès de vous.",
      "business_timezones_1" : "Fuseau horaire de l'entreprise",
      "business_timezones_tooltip_1" : "Remarque : En choisissant cette option, vous vous assurez que vos préférences d'affichage s’alignent avec le fuseau horaire sélectionné pour l'entreprise. Si le fuseau horaire de l'entreprise change, votre fuseau horaire d'affichage s'ajustera automatiquement en conséquence.",
      "recommended_timezones" : "Fuseaux horaires recommandés",
      "all_timezones" : "Tous les fuseaux horaires"
    },
    "availability" : {
      "availability" : "Disponibilité",
      "my_availability" : "Ma disponibilité",
      "my_availability_and_booking_rules" : "Disponibilité et règles de réservation",
      "my_availability_and_booking_rules_description" : "Configurez votre disponibilité et définissez comment et quand ce calendrier accepte les réservations — y compris les intervalles de réunion, les limites et d’autres préférences de planification.",
      "account_availability" : "Disponibilité du compte",
      "timezone" : "Fuseau horaire",
      "working_hours" : "Heures de travail",
      "set_recurring_hours" : "Définissez vos heures de travail récurrentes pour la réunion",
      "select_one" : "Sélectionnez-en un.",
      "sunday" : "Dimanche",
      "monday" : "Lundi",
      "tuesday" : "Mardi",
      "wednesday" : "Mercredi",
      "thursday" : "Jeudi",
      "friday" : "Vendredi",
      "saturday" : "Samedi",
      "widget_preferences" : "Préférences de widget",
      "set_widget_language" : "Définir les préférences comme la langue du widget",
      "language_and_region" : "Langue et région",
      "language" : "Langue",
      "english" : "Anglais",
      "copy_to_all" : "Copier à tous",
      "save_availability" : "Sauvegarder la disponibilité",
      "add_time" : "Ajouter du temps",
      "to" : "À",
      "select_time" : "Sélectionner l'heure",
      "add_user" : "Ajouter un Utilisateur",
      "accessRestricted" : {
        "header" : "Accès privé",
        "message" : "Vous ne faites pas partie de ce compte. Pour obtenir de l'accès, assurez-vous d'inclure un compte via",
        "contact_admin" : "Cette Page n'est Public que pour les administrateurs. Veuillez Contact votre administrateur pour obtenir de l'aide.",
        "button_text" : "Aller aux Réglages de Agence"
      },
      "schedule" : {
        "edit_schedule" : "Modifier le calendrier",
        "schedule_name" : "Nom du calendrier",
        "schedule_name_required" : "Le nom du calendrier est obligatoire.",
        "timezone" : "Fuseau horaire",
        "timezone_placeholder" : "Sélectionnez une option",
        "start_time" : "Heure de début",
        "end_time" : "Heure de fin",
        "add_availability_hour" : "Ajouter une heure de disponibilité",
        "remove_availability_hour" : "Supprimer l’heure de disponibilité",
        "unavailable" : "Indisponible",
        "schedule_created" : "Calendrier créé avec succès",
        "schedule_updated" : "Calendrier mis à jour avec succès",
        "calendars_selected" : "{count} calendrier",
        "calendars_selected_multiple" : "{count} calendriers",
        "select_users_placeholder" : "Rechercher des utilisateurs",
        "edit_default_schedule" : "Modifier ce calendrier",
        "customize_event_type_schedule" : "Personnalisez l’horaire uniquement pour ce calendrier",
        "multi_user_description" : "<b>{count} utilisateurs</b> sélectionnés, mettre à jour leur disponibilité pour <b>{calendar}</b>",
        "selected_calendar" : "calendrier sélectionné",
        "edit_schedule_alert" : "Les mises à jour faites ici s’appliqueront à",
        "schedule" : "Calendrier",
        "no_availability" : "Aucune disponibilité",
        "date_specific_hours_show_more" : "plus",
        "date_specific_hours_show_less" : "moins",
        "date_specific_hours_recurring_meetings_enabled" : "Les heures spécifiques à une date ne peuvent pas être ajoutées car ce calendrier est lié à un calendrier avec des réunions récurrentes activées. Pour continuer, veuillez désactiver les réunions récurrentes.",
        "recurring_incompatible_with_date_hours" : "Les réunions récurrentes ne peuvent pas être activées parce que le calendrier de l’utilisateur a des heures précises, ce qui est incompatible.",
        "incompatible_schedule_with_recurring" : "{user} calendrier contient des heures spécifiques à une date, ce qui est incompatible avec les réunions récurrentes.",
        "incompatible_schedule_with_recurring_calendar" : "Le calendrier contient des heures spécifiques à une date, ce qui est incompatible avec les réunions récurrentes.",
        "recurring_meetings_enabled_multi_user" : "Les réunions récurrentes ne nécessitent qu’un seul membre assigné à l’équipe, et leur calendrier ne doit pas inclure d’heures précises à une date.",
        "weekdays" : "Jours de semaine, {timeRange}",
        "weekdays_hours_vary" : "Jours de semaine, les heures varient",
        "weekend" : "Fin de semaine, {timeRange}",
        "weekend_hours_vary" : "Fin de semaine, les horaires varient",
        "days_hours_vary" : "{days}, les horaires varient",
        "date_specific_hours_tab_name" : "Heures spécifiques à la date",
        "date_specific_hours" : "{count} heures spécifiques à la date",
        "date_specific_hours_1" : "1 heure spécifique à la date",
        "weekly_hours" : "Heures hebdomadaires",
        "custom_schedule" : "Calendrier personnalisé",
        "select_schedule" : "Sélectionner un calendrier",
        "no_schedules_found" : "Aucun calendrier trouvé",
        "untitled" : "Sans titre",
        "error_updating_schedules" : "Une erreur s'est produite lors de la mise à jour des calendriers.",
        "daily" : "Quotidiennement",
        "weekly" : "Hebdomadaire",
        "monthly" : "Mensuel",
        "custom" : "Personnalisé",
        "this_is_required" : "Ceci est obligatoire.",
        "search" : "Rechercher",
        "edit_hours" : "Modifier les heures",
        "schedule_name_duplicate" : "Un calendrier portant ce nom existe déjà.",
        "delete_schedule_title" : "Supprimer le calendrier « {scheduleName} »?",
        "delete_schedule_description" : "Cette action ne pourra pas être annulée. Êtes-vous sûr de vouloir continuer?",
        "delete_schedule_negative_text" : "Annuler",
        "delete_schedule_positive_text" : "Oui, supprimer",
        "active_on" : "Actif sur",
        "weekly_working_hours" : "Heures de travail hebdomadaires",
        "weekly_working_hours_subtext" : "Sélectionnez les jours et les horaires où vous travaillez.",
        "copy_availability_hour" : "Heure de disponibilité des copies",
        "mins" : "Minutes",
        "hours" : "Heures"
      }
    },
    "connections" : {
      "connections" : "Connexions",
      "connect" : "connecter",
      "conferencing" : "Conférence",
      "my_connections" : "Mes connexions",
      "account_connections" : "Connexions de compte",
      "connection_preferences" : "Préférences de connexion",
      "manage_calendars_conferencing_channels" : "Gérer les calendriers et les canaux de conférence",
      "main_integration_calendar" : "Calendrier d'intégration principal",
      "event_integration_calendar" : "Les événements créés sur un calendrier système dont tu fais partie seront également créés sur ce calendrier intégré",
      "2way_sync" : "Synchronisation bidirectionnelle : créez des événements système à partir d'événements réservés sur le calendrier intégré principal",
      "calendars" : "Calendriers",
      "google" : "Google",
      "outlook" : "Perspective",
      "check_for_conflicts" : "Vérifie les conflits",
      "choose_accounts_to_connect" : "Choisis les comptes que tu souhaites connecter",
      "payments" : "Paiements",
      "stripe" : "Bande",
      "ads" : "Publicités",
      "local_service_ads" : "Annonces de services locaux",
      "fire_workflow" : "Déclencheurs de flux de travail pour les événements réservés au moyen de la synchronisation bidirectionnelle",
      "connect_google_outlook" : "Veuillez connecter votre compte Google/Outlook/iCloud pour pouvoir choisir le calendrier principal.",
      "execute_automation" : "Exécuter l'automatisation",
      "save" : "Enregistrer",
      "lsa" : "Annonces de services locaux",
      "no_write_access" : "Vous n'avez pas accès en écriture à ce calendrier",
      "connection_remove_confirmation" : "Vous êtes sur le point de supprimer cette intégration",
      "active" : "Actif",
      "icloud" : {
        "title" : "Intégration iCloud",
        "description" : "Une authentification à deux facteurs et un mot de passe particulier à l'application sont requis pour connecter votre compte.",
        "email" : "Adresse courriel iCloud",
        "password" : "Mot de passe iCloud",
        "connect" : "Connecte-toi",
        "cancel" : "Annuler"
      }
    }
  },
  "appointment_modal" : {
    "select_a_contact" : "Sélectionne un contact",
    "start_time" : "Heure de début",
    "unassigned" : "Non assigné",
    "end_time" : "Heure de fin",
    "search_by_name_email_phone_or_company" : "Recherche par nom, courriel, téléphone ou entreprise",
    "add_new" : "Ajouter nouveau",
    "pick_from_available_contacts" : "Ou choisissez parmi les contacts disponibles",
    "book_appointment" : "Prendre rendez-vous",
    "add_blocked_off_time" : "Ajouter du temps bloqué",
    "recommended_timezones" : "Fuseaux horaires recommandés",
    "all_timezones" : "Tous les fuseaux horaires",
    "calendar" : "Calendrier",
    "repeat" : "Répète",
    "date_and_time" : "Date et heure",
    "close" : "Fermer",
    "team_member" : "Membre de l'équipe",
    "recurring_booking" : "Réservation récurrente",
    "one_slot_booking" : "Réservation à un seul créneau",
    "event_type" : "Type d’événement",
    "occurrences_booked" : "les occurrences seront réservées",
    "repeats" : "Répétitions",
    "booking_details" : "Détails de la réservation",
    "showing_slots_in_this_timezone" : "Affichage des créneaux horaires dans ce fuseau horaire :",
    "update_contact_tz" : "Mets également à jour le fuseau horaire du contact pour",
    "date" : "Date",
    "slot" : "Fente",
    "calendar_default" : "Calendrier par défaut",
    "custom" : "Personnalisé",
    "meeting_notes" : "(p. ex.) Notes de réunion pour notre prochain rendez-vous",
    "out_of_office" : "(par exemple) Absent du bureau pour la semaine!",
    "standard" : "Par défaut",
    "appointment_title" : "Titre du rendez-vous",
    "event_title" : "Titre de l’événement",
    "appt_with_bob" : "(par exemple) Rendez-vous avec Bob",
    "vacation" : "(par exemple) Vacances",
    "show_notes" : "Afficher les notes",
    "hide_notes" : "Masque les notes",
    "additional_preferences" : "Préférences supplémentaires",
    "meeting_location" : "Lieu de la réunion",
    "appointment_status" : "Statut du rendez-vous",
    "appt_description" : "Description du rendez-vous",
    "recurring_details" : "Détails récurrents",
    "event_description" : "Description de l’événement",
    "in_contact_timezone" : "Dans le fuseau horaire du contact",
    "vacation_message" : "En vacances ? Vous prenez un peu de temps libre? Bloquez du temps sur votre calendrier pour empêcher les clients de prendre des rendez-vous (les rendez-vous existants resteront sur votre calendrier).",
    "contact" : "Contact",
    "delete" : "Supprimer",
    "cancel" : "Annuler",
    "back" : "Retour",
    "pick_available_contacts" : "Ou choisissez parmi les contacts disponibles",
    "no_contacts_found" : "Aucun contact trouvé",
    "found" : "trouvé",
    "select_one" : "Sélectionnez une option",
    "tz_tooltip" : "Cela n'est important que si vous utilisez des valeurs personnalisées, telles que appointment_start_time, appointment_end_time, appointment_timezone, etc. dans vos communications sortantes avec vos clients ou clients. Et ce qu'il fait simplement, c'est convertir les détails susmentionnés en leur heure locale.",
    "meeting_location_tooltip" : "Le lieu de la réunion sera défini comme configuré dans le calendrier.",
    "appt_meeting_location_tooltip" : "L'utilisateur peut définir le lieu de la réunion spécifique au rendez-vous.",
    "gmeet_tooltip" : "Assurez-vous que le membre de l'équipe concerné dispose d'un calendrier Google défini comme calendrier principal.",
    "zoom_tooltip" : "Veuillez vous assurer que le membre de l'équipe concerné a intégré Zoom",
    "enter_meeting_location" : "Saisis le lieu de la réunion",
    "save_appointment" : "Enregistrer le rendez-vous",
    "save_event" : "Sauvegarder l'événement",
    "search_contacts" : "Recherche par nom, courriel, téléphone ou entreprise",
    "recurring_slots" : "{recurringSlotsLength}/{count}",
    "custom_timezone" : "Fuseau horaire personnalisé",
    "system_timezone" : "Fuseau horaire du système",
    "contact_timezone" : "Fuseau horaire de contact",
    "account_timezone" : "Fuseau horaire du compte",
    "an_error_occurred" : "Une erreur s’est produite"
  },
  "popup" : {
    "calendar" : "Calendrier",
    "appointment_owner" : "Propriétaire du rendez-vous",
    "source" : "Source",
    "booked_by" : "Réservé par",
    "view_activity_log" : "Afficher le journal d’activité",
    "status" : "Statut",
    "cancel_appointment" : "Annuler le rendez-vous",
    "cancel_all" : "Annuler tout",
    "google_event" : "Événement Google",
    "outlook_event" : "Événement Outlook",
    "blocked_slot" : "Créneau bloqué",
    "appointment" : "Rendez-vous",
    "confirmed" : "Confirmé",
    "unconfirmed" : "Non confirmé",
    "cancelled" : "Annulé",
    "showed" : "Montré",
    "no_show" : "Pas de spectacle",
    "invalid" : "Invalide",
    "more" : "Plus",
    "less" : "Moins",
    "edit" : "Modifier",
    "reschedule_all" : "Replanifier tout",
    "guests" : "Invité(s)",
    "guest_count" : "Nombre d'invités"
  },
  "create_calendar" : {
    "calendar_name" : "Nom du calendrier",
    "calendar_logo" : "Logo du calendrier",
    "select_team_member" : "Sélectionner les membres de l’équipe",
    "select_single_team_member" : "Sélectionner un membre de l’équipe",
    "eg_outbound_reach" : "(par exemple) Portée sortante",
    "description" : "Description",
    "amount" : "Montant",
    "description_placeholder" : "Rédige une description",
    "meeting_duration" : "Durée de la réunion",
    "meeting_location" : "Lieu de réunion",
    "seats_per_class" : "Sièges par classe",
    "group" : "Groupe",
    "custom_url" : "URL personnalisée",
    "meeting_invite_title" : "Titre de l’invitation à la réunion",
    "event_color" : "Couleur de l'événement",
    "availability_type" : "Type de disponibilité",
    "new_calendar" : "Nouveau calendrier",
    "add_description" : "Ajoute une description",
    "remove_description" : "Supprime la description",
    "booking_availability" : "Disponibilité des réservations",
    "slug_tooltip" : "Personnaliser l' URLde réservation de Widget",
    "meeting_location_tooltip" : "Les liens de réunion sont affichés dans les événements du calendrier en tant que « lieu de réunion » et vous permettent d’ajouter des éléments tels que des liens de zoom pour l’événement.",
    "advanced_settings" : "Paramètres avancés",
    "show_more_schedule" : "Afficher plus",
    "show_more_helper_text" : "Pour personnaliser davantage vos heures d’ouverture, veuillez consulter les paramètres avancés",
    "reschedule_preference" : "Rééchelonnez la préférence",
    "reschedule_preference_subtext" : "Si un {contactLabel} reprogramme un rendez-vous :",
    "reassign_through_round_robin" : "Réaffecter par le biais d'un système à la ronde",
    "keep_same_assinged_user" : "Conserve le même propriétaire de rendez-vous",
    "new_appointment_preference" : "Nouvelle préférence de rendez-vous",
    "new_appointment_preference_text" : "Réservez toujours avec l'utilisateur assigné à {contactLabel}",
    "new_appointment_preference_subtext" : "Réservez de nouveaux rendez-vous avec l’utilisateur assigné à {contactLabel} au lieu d’utiliser la planification au tour de table.",
    "cancel" : "Annuler",
    "confirm" : "Confirme",
    "service_calendar_name" : "Nom du service",
    "service_logo" : "Logo du service",
    "service_select_team_member" : "Sélectionne un membre du personnel",
    "service_duration" : "Durée du service",
    "appointment_invite_title" : "Titre de l'invitation à un rendez-vous",
    "payment_placeholder" : "Saisissez une description qui sera affichée à l'utilisateur pour l'informer du paiement",
    "deposit_amount" : "Montant du dépôt",
    "collect_deposit_amount" : "Accepte le paiement partiel",
    "percentage" : "Pourcentage",
    "total_amount" : "Montant total",
    "enter_meeting_location" : "Saisissez le lieu de réunion.",
    "accept_payments" : "Accepter les paiements",
    "aria" : {
      "should_accept_payment" : "Devrait accepter le paiement"
    },
    "calendar_name_tooltip" : "Nom du calendrier à afficher Tous les Widget de réservation",
    "booking_availability_tooltip" : "Collection les jours et l'heure pendant lesquels les réservations peuvent être faites. Il s'agit de votre par défaut",
    "select_team_member_tooltip" : "Sélectionner le ou les membres du groupe qui prendront cette conférence",
    "seats_per_class_tooltip" : "Collection le nombre Max de membres autorisés pour réserver cette classe. Une fois tous les Sièges remplis, les Fenêtres de temps ne seront plus disponibles pour la réservation",
    "meeting_color" : "Couleur de la conférence",
    "meeting_duration_tooltip" : "Cela définit votre code d'accord, en déterminé la durée"
  },
  "calendar_advanced" : {
    "general" : {
      "quick_tip" : "Astuce rapide",
      "timezone_change_tip" : "Les fuseaux horaires peuvent être modifiés à tout moment dans les préférences de fuseau horaire",
      "save" : "Enregistrer",
      "close" : "Fermer",
      "meeting_details" : "Détails de la réunion",
      "availability" : "Disponibilité",
      "forms_and_payment" : "Formulaires et paiement",
      "notifications_and_additional_options" : "Notifications et options supplémentaires",
      "connections" : "Connexions",
      "customizations" : "Personnalisations",
      "create" : "Créer",
      "edit" : "Modifier",
      "equipments" : "Chambres et équipements",
      "service_details" : "Détails du service",
      "saving_changes" : "Une minute - Sauvegarder les cours de la dernière dynamique...",
      "calendar_id": "Identifiant du calendrier",
      "saveCalendarSuccess": "Calendrier enregistré avec succès"
    },
    "meeting_details" : {
      "meeting_location" : "Lieu de réunion",
      "enter_meeting_location" : "Entre le lieu de la réunion",
      "click_to_upload" : "Clique pour télécharger",
      "square" : "Carré",
      "circle" : "Cercle",
      "remove_logo" : "Supprime le logo",
      "meeting_invite_title_tooltip" : "Il s'agit du titre de la conférence de calendrier qui moiss in votre rendez-vous de la liste, de la vue de calendrier et du calendrier",
      "event_color_tooltip" : "Choisissez une couleur pour cet événement de réservation. Les couleurs sont synchronisées avec les événements dans Google Agendas.",
      "enter_a_name" : "Veuillez saisir un nom",
      "enter_an_event_title" : "Veuillez saisir le titre d’un événement",
      "high_priority" : "Haute priorité",
      "medium_priority" : "Priorité moyenne",
      "low_priority" : "Faible priorité",
      "priority" : "Priorité",
      "custom" : "Personnalisé",
      "zoom_not_added" : "L’utilisateur n’a pas encore connecté son compte Zoom",
      "opt_avail" : "Optimise la disponibilité",
      "opt_equal" : "Optimise pour une distribution égale",
      "team_members" : "Sélectionner les membres de l’équipe",
      "team_members_location" : "Sélectionner des membres du groupe et attribuer un emplacement pour la conférence",
      "team_member" : "Sélectionner un membre de l'équipe",
      "team_member_location" : "Sélectionner des membres du groupe et attribuer un emplacement pour la conférence",
      "meeting_location_required" : "Le lieu de la réunion est requis",
      "meeting_details" : "Détails de la réunion",
      "meeting_details_description" : "Voici les détails qui seront affichés sur la page de liste du calendrier.",
      "or_drag_and_drop" : "ou glisser-déposer",
      "service_details" : "Détails du service",
      "team_member_disabled_recurring_tooltip" : "Les réunions récurrentes n'autorisent qu'un seul membre de l'équipe. Pour ajouter plusieurs membres de l'équipe, veuillez désactiver les réunions récurrentes.",
      "team_member_disabled_class_booking_tooltip" : "Un seul membre de l'équipe peut être ajouté au calendrier de réservation d'une classe.",
      "advanced_settings" : "Paramètres avancés",
      "enable_contact_assigned_to_setting" : "Pour activer ce paramètre, le formulaire doit être le premier dans l’ordre des widgets. Veuillez réorganiser l'ordre des widgets depuis l'onglet Formulaires et paiement.",
      "reschedule_preference_setting_tooltip" : "Choisissez à qui le rendez-vous doit être attribué lorsqu’un {contactLabel} reprogramme à partir du widget de réservation.",
      "appointment_preference_tooltip" : "Choisissez si les nouveaux rendez-vous doivent toujours être réservés avec l’utilisateur assigné à {contactLabel}. Si un {contactLabel} a un utilisateur assigné, cet utilisateur aura la priorité ; sinon, l'attribution se fera au tour de table. Conseil : Désactivez « Autoriser la sélection du personnel » pour empêcher les bookers de changer le membre du personnel sur le widget de réservation.",
      "add_location" : "Ajouter un emplacement",
      "multiple_locations_neo" : "Les Adresses multiples sont uniquement pris en charge via le Neo Widget.",
      "make_owner" : "Devenir propriétaire",
      "only_one_team_member" : "Un seul membre de l'équipe est autorisé lorsque plusieurs emplacements sont ajoutés.",
      "ask_the_booker_error_message" : "L'emplacement d'Ask the Booker existe déjà",
      "enter_location" : "Entrer la valeur de l'emplacement",
      "enter_display_label" : "Saisir l'étiquette d'affichage",
      "add_display_label" : "Ajouter une étiquette d'affichage",
      "multiple_location_support_message" : "Les Adresses multiples sont uniquement pris en charge via le Neo Widget.",
      "only_one_team_member_personal_calendar" : "Un seul membre de l'équipe est autorisé pour les réservations individuelles ",
      "ms_teams_not_added" : "L’utilisateur n’a pas encore connecté son compte Microsoft Teams",
      "enable_new_appt_preference" : "Préférences de rendez-vous actives",
      "enable_new_appt_preference_desc" : "L’activation de « <b>Toujours réserver avec l’utilisateur assigné à {contactLabel}</b> » définira automatiquement le <b>formulaire</b> comme première étape dans l’ordre des widgets.",
      "location_exists_toast" : "Conférence déjà ajoutée",
      "not_supported_with_multiple_team_members" : "Non pris en charge avec plusieurs membres du groupe",
      "not_supported_personal_calendar" : "Non pris en charge in le calendrier personnalisé",
      "not_supported_class_booking" : "Non pris en charge in la classe des services",
      "not_supported_collective_booking" : "Non pris en charge in le calendrier CRÉNEAU",
      "not_supported_service_booking" : "Non pris en charge in les services",
      "not_supported_round_robin" : "Non pris en charge in le calendrier Tour de table",
      "not_supported_event" : "Non pris en charge in le calendrier des événements",
      "calendar_logo_tooltip" : "Sélectionnez un Logo pour être Mensuel pour la réservation de Widget",
      "calendar_name_tooltip" : "Nom du calendrier à afficher Tous les Widget de réservation",
      "description_tooltip" : "Description du calendrier, à afficher",
      "group_tooltip" : "Vous pouvez attribuer ce calendrier à un groupe (si modifié). Utilisateur de l'accès au groupe peut être parcouru et réserver des calendriers in ce groupe",
      "custom_url_tooltip" : "Personnaliser l' URLde réservation de Widget",
      "meeting_color_tooltip" : "Choisir une couleur pour cet événement de réservation. Les couleurs sont synchronisées avec les événements in Google Agenda",
      "add_display_label_tooltip" : "Pour masquer l'emplacement, plusieurs Options sont disponibles",
      "meeting_location_tooltip" : "OK",
      "team_members_location_tooltip" : "Sélectionner les membres du groupe qui prendront cette conférence",
      "meeting_distribution" : "Conférence",
      "meeting_distribution_tooltip" : "OK",
      "opt_avail_tooltip" : "Attribuez des réunions aux membres du groupe qui sont disponibles à la Date sélectionnée, même pour les réservations. Optimise l'utilisation de l'entonnoir et les réservations réussie",
      "opt_equal_tooltip" : "Publier des réunions de la même manière entre les membres du groupe via le suivi des réservations. Priorité sur la disponibilité",
      "priority_tooltip" : "Collection les préférences pour attribuer des réunions lorsque plusieurs membres du groupe sont disponibles. Les membres les plus supérieurs seront considérés en premier pour les réservations, via des membres de la moyenne et du bas",
      "contact_routing_preference" : "Préférences de routage des Contact",
      "contact_routing_preference_tooltip" : "Définissez comment les nouveaux {contactsLabel} et les anciens sont attribués aux membres de l'équipe, soit par tour de table ou par leur propriétaire initial.",
      "team_members_location_owner_tooltip" : "L'utilisateur PRIMAIRE qui est propriétaire de la conférence et fournit le dernier emplacement de la conférence",
      "owner" : "Propriétaire",
      "upload_from_system" : "Téléverser à partir du système",
      "choose_from_media_storage" : "Choisissez dans la médiathèque",
      "only_one_team_member_allowed" : "Un seul membre du groupe est autorisé.",
      "at_least_two_team_members_required" : "Au moins 2 membres de l’équipe sont requis",
      "at_least_one_team_member_required" : "Au moins un membre de l’équipe est obligatoire."
    },
    "availability" : {
      "my_availability" : "Ma disponibilité",
      "set_availability" : "Définis ici ta disponibilité pour le calendrier.",
      "standard" : "Standard",
      "custom" : "Personnalisé",
      "to" : "À",
      "copy_to_all" : "Copier à tous",
      "add_time" : "Ajouter du temps",
      "recurring_meeting" : "Réunion récurrente",
      "recurring_info" : "Un seul utilisateur par calendrier pour les réservations récurrentes",
      "repeat" : "Répète",
      "times_to_repeat" : "Temps à répéter",
      "slots_unavailable" : "Si les créneaux ne sont pas disponibles?",
      "overlap_status" : "Statut des rendez-vous pour les créneaux horaires qui se chevauchent ",
      "meeting_interval" : "Intervalle des réunions",
      "meeting_duration" : "Durée de la réunion",
      "minimum_scheduling" : "Préavis de planification minimum",
      "date_range" : "Plage de dates",
      "maximum_bookings_per_day" : "Nombre maximal de réservations par jour",
      "maximum_bookings_per_slot" : "Nombre maximum de réservations par créneau",
      "maximum_bookings_per_slot_per_user" : "Nombre maximal de réservations par créneau (par utilisateur)",
      "seats_per_class" : "Sièges par classe",
      "pre_buffer_time" : "Temps de pré-mise en mémoire tampon",
      "post_buffer_time" : "Temps de mise en mémoire tampon après publication",
      "pre_buffer_tooltip" : "Le pré-tampon est un temps supplémentaire qui peut être ajouté avant un rendez-vous, ce qui permet d'avoir plus de temps pour se préparer",
      "post_buffer_tooltip" : "Le post-buffer est du temps supplémentaire qui peut être ajouté après un rendez-vous, permettant ainsi plus de temps pour conclure",
      "buffer_time" : "Temps de latence",
      "daily" : "Quotidiennement",
      "weekly" : "Hebdomadaire",
      "monthly" : "Mensuel",
      "skip_booking" : "Ignorer la réservation des créneaux indisponibles",
      "continue_booking" : "Poursuivre la réservation",
      "book_next_available" : "Réservez le prochain créneau disponible",
      "confirmed" : "Confirmé",
      "unconfirmed" : "Non confirmé",
      "enter_valid_hours" : "Veuillez saisir des heures d'ouverture valides",
      "enter_valid_avail" : "Veuillez saisir une disponibilité personnalisée valide",
      "availability_type_tooltip" : "Choisissez la disponibilité standard pour les réservations régulières proposées chaque semaine. Choisissez Personnalisé pour les réservations uniquement disponibles à des dates précises.",
      "meeting_interval_tooltip" : "L'intervalle de réunion reflète la durée entre les créneaux de réservation qui seront affichés dans le calendrier. Pour un événement de 30 minutes qui devrait être disponible en haut de chaque heure, l’intervalle serait de 1 heure. Pour un événement de 30 minutes qui devrait être disponible toutes les 30 minutes, l’intervalle serait de 30 minutes.",
      "date_range_tooltip" : "Les événements peuvent être planifiés au cours des n prochains jours.",
      "maximum_bookings_per_day_tooltip" : "Nombre Max de réunions autorisées par jour Allumer ce calendrier",
      "maximum_bookings_per_slot_tooltip" : "Nombre maximal de rendez-vous autorisés par créneau pour l'utilisateur (si le nombre de rendez-vous dépasse le créneau donné pour l'utilisateur, il passe alors à l'utilisateur suivant dans la file d'attente à tour de rôle ou marque le créneau indisponible pour la réservation du client potentiel).",
      "add_days" : "Ajouter des jours",
      "month_on_day" : "Mensuellement le jour",
      "month_on_last_day" : "Mensuellement le dernier jour",
      "day" : "Jour",
      "week" : "Semaine",
      "month" : "Mois",
      "mins" : "Minutes",
      "hours" : "Heures",
      "days" : "Jours",
      "weeks" : "Semaines",
      "months" : "Mois",
      "meeting_interval_error" : "L'intervalle de rencontre doit être compris entre 5 minutes et 12 heures",
      "meeting_duration_error" : "La durée de la réunion doit être comprise entre 1 min et 12 heures",
      "buffer_time_error" : "Le temps tampon doit être inférieur à 12 heures",
      "appointment_interval" : "Intervalle de rendez-vous",
      "appointment_duration" : "Durée du rendez-vous",
      "maximum_appointments_per_day" : "Nombre maximal de rendez-vous par jour",
      "subTitle" : "Choisis la date pour définir des heures spécifiques",
      "heading_1" : "Heures hebdomadaires disponibles",
      "scheduling_availability_heading" : "Disponibilité de réservation",
      "tooltip_1" : "Définir votre horaire de disponibilité hebdomadaire. Ce sont vos heures normales qui seront appliquées uniformément sur une base hebdomadaire",
      "heading_2" : "Quand es-tu disponible ?",
      "unavailable_label" : "Indisponible",
      "tooltip_2" : "Ajustez votre horaire pour des dates spécifiques. Remplacez vos horaires hebdomadaires habituels en marquant la disponibilité ou l'indisponibilité pour les dates sélectionnées.",
      "date_specific_level" : "Ajouter des heures spécifiques à la date",
      "specific_hours_button" : "Heures spécifiques à la date",
      "specific_hours_description" : "Remplacez votre disponibilité pour des dates spécifiques quand vos heures diffèrent de vos heures hebdomadaires normales.",
      "overlap_error" : "Les plages horaires ne peuvent pas se chevaucher",
      "apply" : "Applique",
      "copy_times_to" : "Copier les heures vers",
      "no_date_specific_heading" : "Aucune date et aucune heure particulières ajoutées",
      "no_date_specific_description" : "Vous pouvez ajouter/supprimer une date et une heure particulières à vos disponibilités.",
      "recurring_disabled_conditions_tooltip" : "Les réunions récurrentes sont des Handicapés. Pour les chercher, assurez-vous que le calendrier ne compte qu’un seul groupe et n’a pas une heure spécifique à la date.",
      "date_specific_hours_disabled_conditions_tooltip" : "Pour inclure une heure spécifique à la date, assure-toi que les réunions récurrentes sont désactivées.",
      "recurring_disable_event_calendar_conditions" : "Les réunions récurrentes sont des Handicapés. Pour les obtenir, assurez-vous qu’aucune heure spécifique à la date n’est ajoutée.",
      "service_duration" : "Durée du service",
      "service_interval" : "Intervalle de service",
      "service_interval_tooltip" : "L'intervalle de réunion définit la fréquence à laquelle les créneaux de réservation apparaissent sur le calendrier. Par exemple, pour un événement de 30 minutes, un intervalle d'une heure signifie que les créneaux apparaissent toutes les heures. Un intervalle de 30 minutes signifie que les créneaux apparaissent toutes les 30 minutes.",
      "service_duration_tooltip" : "Cela fixe la durée de ton rendez-vous, déterminant combien de temps il durera.",
      "minimum_scheduling_tooltip" : "Cela définit le temps minimum requis pour prendre rendez-vous via le widget de calendrier. Par exemple, s'ils sont définis sur 4 heures, les rendez-vous ne peuvent pas être pris dans les 4 heures suivant leur heure de début ; les réservations doivent être faites au moins 4 heures à l'avance.",
      "look_busy_title" : "Regardez occupé",
      "look_busy_helper_text" : "Cache un pourcent de tes Widget de rendez-vous disponibles in",
      "look_busy_percentage_description" : "Masquer le nombre d'emplacements disponibles par x%",
      "maximum_bookings_per_slot_tooltip_personal" : "Limite combien de réunions peuvent être précédentes pour la même fenêtre de temps",
      "enable_recurring_title" : "Conférence récurrente active",
      "enable_recurring_desc" : "L'activation de l'option Tous <b>les réunions récurrentes</b> désactivera automatiquement les réglages de l'appelant, car ils ne peuvent pas coexister :",
      "date_specific_hours" : "Toutes <b>les heures spécifiques à la date</b> seront prise en charge.",
      "multiple_team_members" : "<b>Plusieurs membres du groupe</b> seront désactivés : un seul membre du groupe peut rester in ce calendrier.",
      "partial_payments" : "<b>Les paiements incomplet</b> seront Handicapés et le montant Plein sera collecté.",
      "select_team_member_to_keep" : "Sélectionnez un groupe pour le Garder in ce calendrier :",
      "select_team_member" : "Sélectionner des membres du groupe",
      "partial_payments_disabled" : "Comme les paiements incomplet seront Handicapés, comment vous souhaitez collecter le montant total pour le rendez-vous récurrent?",
      "enable_date_specific_hours" : "Activer des heures spécifiques à la Date",
      "enable_date_specific_hours_desc" : "L'activation de toutes <b>les heures spécifiques à la date</b> désactivera automatiquement les informations de l'utilisateur, car elles ne peuvent pas coexister :",
      "recurring_meetings_disabled" : "<b>Les réunions récurrentes seront désactivées</b>, {contactsLabel} ne pourra réserver que des rendez-vous individuels en fonction des dates disponibles que vous aurez définies.",
      "payment_preference" : "Préférences de Paiement : préférences",
      "team_members_in_this_calendar" : "Groupes de membres in ce calendrier",
      "other_team_members" : "Autres membres du groupe ( Non ajouté à ce calendrier)",
      "select_team_member_tooltip" : "Sélectionner le ou les membres du groupe qui prendront cette conférence",
      "meeting_duration_tooltip" : "Cela définit votre code d'accord, en déterminé la durée",
      "date_specific_hours_tooltip" : "Modifier votre calendrier pour des dates spécifiques. Remplacez votre horaire de Mensuel en marquant l'indisponibilité pour les dates",
      "recurring_meeting_tooltip" : "Des réunions plus actives pour répéter plusieurs fois sur une semaine",
      "repeat_frequency_tooltip" : "Sélectionner la fréquence de cet événement",
      "time_to_repeat_tooltip" : "Collection le nombre Total de répétitions",
      "slots_unavailable_tooltip" : "Plus d' Date in une réservation récurrente sont déjà réservés",
      "skip_booking_tooltip" : "Seuls les créneaux disponibles seront réservés. Toutes les dates indisponibles in la ligne récurrente seront rejetées",
      "force_book" : "Réserver obligatoire",
      "force_booking_tooltip" : "Tous les créneaux seront réservés, même si vous êtes un conflit. Utilisez avec attention pour éviter une double réservation",
      "book_next_available_tooltip" : "Si un formulaire sélectionné n’est pas disponible, Réserver les éléments suivants",
      "slot_interval_tooltip" : "Collection l'intervalle entre les créneaux de début des créneaux suivants disponibles. Pour des modèles, des si votre durée de AM conférence sont de AM minutes et de la Collection d'occasion, un utilisateur peut être réservé à )",
      "minimum_scheduling_notice_tooltip" : "Utilisateur obligatoire de réserver des réunions au moins cette Date in l'avance",
      "date_range_preferences_tooltip" : "Collection jusqu'à où les réservations futures peuvent être faites de la Date d'aujourd'hui",
      "maximum_bookings_per_slot_preferences_tooltip" : "Limite combien de réunions peuvent être précédentes pour la même fenêtre de temps",
      "maximum_bookings_per_slot_per_user_preferences_tooltip" : "Limite combien de réunions peuvent être précédentes pour la même fenêtre de temps (par Utilisateur)",
      "pre_buffer_time_tooltip" : "Date à bloquer avant tout, actif pour plus de Date à préparer",
      "post_buffer_time_tooltip" : "Date à bloquer après tout, actif pour plus de Date à conclure",
      "seats_per_class_tooltip" : "Collection le nombre Max de membres autorisés pour réserver cette classe. Une fois tous les Sièges remplis, les Fenêtres de temps ne seront plus disponibles pour la réservation",
      "maximum_bookings_per_slot_per_user_tooltip" : "Limite combien de réunions peuvent être précédentes pour la même fenêtre de temps (par Utilisateur)",
      "repeat_frequency" : "Répète la Fréquence",
      "slot_interval" : "Fente des secondes",
      "skip_booking_helper_text" : "Seuls les créneaux disponibles seront réservés. Toutes les dates indisponibles in la ligne récurrente seront rejetées",
      "force_book_helper_text" : "Tous les créneaux seront réservés, même si vous êtes un conflit. Utilisez avec attention pour éviter une double réservation",
      "book_next_available_helper_text" : "Si une fenêtre sélectionnée n'est pas disponible, Réserver les éléments suivants disponibles, tous les mêmes calendriers récurrents (par exemple, OK",
      "bulk_edit" : "Modification en masse",
      "select_users" : "Sélectionner des utilisateurs",
      "select_all" : "Sélectionner tout",
      "times_to_repeat_tooltip" : "Définir le nombre total de récurrences"
    },
    "forms_payment" : {
      "forms" : "Formulaires",
      "forms_sub" : "Définis les préférences du formulaire de planification de publication.",
      "select_form" : "Sélectionne le formulaire",
      "enable_same_user_assignment" : "Affectez des contacts aux membres de leur équipe de calendrier respective à chaque fois qu'un rendez-vous est réservé",
      "sticky_contacts" : "Champs pré-remplis (contacts collants)",
      "confirmation_page" : "Page de confirmation",
      "default" : "Par défaut",
      "redirect_url" : "URL de redirection",
      "thank_you" : "Message de remerciement",
      "enter_url" : "Entrez l'URL",
      "amount_tab_hidden_label" : "Espace réservé pour l'onglet de quantité",
      "percentage_tab_hidden_label" : "Espace réservé pour l'onglet de pourcentage",
      "pixel_id" : "Meta Id pixel (option En option)",
      "auto_confirm" : "Confirmer automatiquement les nouvelles réunions du calendrier",
      "configure_payment" : "Configurer les options de paiement",
      "accept_payments" : "Accepter les paiements",
      "test" : "Essai",
      "live" : "En direct",
      "enable_guests" : "Ajouter des invités",
      "add_guest_tooltip" : "Ajouter un invité permettra à votre participant d'ajouter plusieurs participants au même rendez-vous",
      "add_guest_custom_form_tooltip" : "L'activation de cette option enverra un courriel généré par le système aux invités avec un lien vers le formulaire personnalisé une fois leur rendez-vous confirmé. Pour éviter les courriels en double, assurez-vous qu’un courriel de confirmation séparé n’est pas déjà configuré pour les invités. (Vérifiez ceci dans l'onglet Notifications > Notification de confirmation)",
      "add_guest_same_form_check" : "Envoyer le même formulaire de collecte d'information par courrier à tous les invités",
      "payment_tooltip" : "Le paiement ne sera pris en compte que pour le participant principal et non pour les invités.",
      "default_form" : "Par défaut (prénom, nom, courriel, téléphone, notes)",
      "select_form_tooltip" : "Si vous souhaitez collecter plus d'information que le prénom, le nom, le courriel et le téléphone standard auprès des personnes qui réservent sur ce calendrier, créez un formulaire personnalisé dans Sites Web > Formulaires > Générateur, puis sélectionnez le formulaire au moyen de la liste déroulante ci-dessous.",
      "confirmation_page_tooltip" : "Une fois que quelqu'un effectue une réservation, vous pouvez choisir de lui afficher un message personnalisé sur la même page (par défaut) ou du rediriger vers une page de votre choix (rediriger).",
      "add_guest_collect_email" : "Nom et courriel",
      "add_guest_count_only" : "Compter seulement",
      "custom_email_notification" : "Envoyer un formulaire personnalisé aux invités",
      "consent_label" : "Case à cocher de consentement",
      "consent_input_placeholder" : "Ajouter du texte de consentement",
      "same_user_assignment_tooltip" : "Pour activer ce paramètre, le formulaire doit être le premier sur le widget. Réorganisez le widget pour positionner le formulaire en premier pour activer ce paramètre.",
      "consent_tooltip" : "Activez cette option pour permettre d’obtenir le consentement de {contactsLabel} quand ils fournissent leur numéro de téléphone lors du processus de réservation de rendez-vous.",
      "stripe_error" : "Jusqu’à deux décimales (exemple : 25,99)",
      "auto_confirm_service" : "Confirmer automatiquement les nouveaux rendez-vous",
      "service_form_message" : "Si un contact réserve plusieurs services, il ne verra que le formulaire par défaut dans le menu des services",
      "deposit_amount_error" : "Le montant du dépôt doit être inférieur au montant total.",
      "deposit_percentage_error" : "Le pourcentage de dépôt doit être inférieur à 100 %.",
      "partial_payment_tooltip" : "Activer les paiements pour collecter le montant de l'acompte auprès des clients pendant le flux de réservation de rendez-vous",
      "partial_payment_enable_error" : "Le montant total saisi doit être supérieur à 0 pour permettre des paiements partiels.",
      "payment_disable_text_integration" : "Intègre un fournisseur de paiement sous Paiements > Intégrations pour commencer à accepter les paiements",
      "payment_disable_text_recurring" : "L'option Accepter le paiement n'est pas disponible pour les réunions récurrentes. Désactivez les paiements récurrents pour activer les paiements.",
      "date_and_time_selector" : "Sélecteur de date et d’heure",
      "form_selector" : "Formulaire",
      "order_step" : "Étape",
      "widget_order_label" : "Commande de widgets",
      "widget_order_tool_tip" : "Réorganiser l'ordre de « Sélecteur de date et d'heure » et de « Formulaire » dans le widget du calendrier. Faites simplement glisser et réordonner selon vos préférences.",
      "widget_re_order_tooltip" : "La réorganisation n'est disponible qu'avec le style de widget Neo. Passez à Neo pour activer la réorganisation.",
      "widget_re_order_disabled_tooltip" : "Pour réorganiser l'ordre des widgets, veuillez désactiver « Préférence pour les nouveaux rendez-vous (toujours réserver avec l'utilisateur assigné à {contactLabel}) » dans la section Détails de la conférence > Membres de l'équipe > Paramètres avancés.",
      "payment_description_error" : "Limite maximale de caractères de 1000 atteinte",
      "widget_multiple_location_disabled_tooltip" : "Le widget classique ne prend pas en charge plusieurs lieux de réunion. Veuillez supprimer tous les emplacements supplémentaires pour utiliser le widget classique",
      "recurring_payment_label" : "Paiement des rendez-vous récurrents",
      "enable_payments_for_guests" : "Activer les paiements pour les invités",
      "guest_payment_description" : "Comme vous avez activé l'option « Invités », vous pouvez également charge des invites lors de la réservation.",
      "charge_per_attendee" : "Par charge",
      "charge_per_attendee_description" : "Multipliez le montant Total via le nombre de participants (y compris les invités) Quand le montant est collecté lors de la réservation.",
      "click_confirm_description" : "Cliquez sur Enregistrer pour appliquer ces modifications.",
      "multiply_amount_guests" : "Percevoir le paiement pour tous les participants",
      "multiply_amount_guests_description" : "Lorsqu’il est activé, le montant à collecter lors de la réservation sera multiplié par le nombre Total de participants, y compris les invités",
      "first_appointment_only" : "charge pour le premier rendez-vous uniquement",
      "all_appointments" : "charge pour tout rendez-vous à l'avance",
      "no_payment_provider_connected" : "Aucun paiement connecté",
      "no_default_payment_provider" : "Aucun paiement connecté",
      "provider_not_supported" : "Le paiement par défaut n'est pas pris en charge",
      "manage_payment_provider" : "Gérer les fournisseurs de Paiement",
      "supported_providers" : "Fournisseurs pris en charge",
      "paypal_razorpay_helper_text" : "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers",
      "rearrange_widget_order" : "Widget de réorganisation",
      "change_form_order" : "D' in :",
      "change_form_order_desc" : "<b>Préférence pour les nouveaux rendez-vous (toujours réserver avec l'utilisateur assigné à {contactLabel})</b> sera désactivée. Cela signifie que les rendez-vous peuvent être réservés avec n’importe quel membre disponible de l'équipe, au lieu d’être limités à l’utilisateur assigné à {contactLabel}.",
      "enable_mandatory_guest" : "Créer au moins une invite obligatoire. Les domaines des invitations seront pré-ouverture et doivent être remplis avant de réserver.",
      "enable_mandatory_guest_count" : "Nombre d'invitations obligatoires pour le Widget",
      "require_guest_for_booking" : "Invités pour la réservation",
      "sticky_contacts_tooltip" : "Pré-remplir les champs pour les {contactsLabel} connus.",
      "auto_confirm_tooltip" : "HighLevel_ENUS_FRCA sans exiger une approbation manuelle. Désactiver ce Si vous souhaitez obtenir de l'avis et confirmer toutes les réservations manuelles avant qu'il ne soit prévu",
      "confirm_tooltip" : "Une fois que quelqu'un effectue une réservation, vous pouvez lui afficher un Message personnalisé sur la même Page (par défaut) ou le rediriger vers une Page de votre choix (URL de redirection)",
      "facebook_pixel_id_tooltip" : "",
      "accept_payments_tooltip" : "Activer la Collection de Paiement lors des réservations",
      "total_amount_tooltip" : "Collection la charge Total pour la conférence",
      "deposit_amount_tooltip" : "Montant à collecter lors de la réservation en guise d'acompte",
      "multiply_amount_guests_all_guests" : "Percevoir le paiement pour tous les participants, y compris les invités",
      "multiply_amount_guests_all_guests_tooltip" : "Lorsqu’il est activé, le montant à collecter lors de la réservation sera multiplié par le nombre Total de participants, y compris les invités",
      "payment_description" : "Description du Paiement",
      "payment_description_tooltip" : "Inclure en option des détails utile pour le paiement",
      "test_mode_warning" : "Mode d'essai dynamique : aucune vente réel n'est traitée.",
      "pixel_id_tooltip" : "Téléverser des Widget Meta réservation Id activités",
      "forms_description" : "Configurer les domaines et le flux de votre réservation",
      "payment_mode" : "Mode de Paiement",
      "payment_mode_tooltip" : "Activez le mode d'essai et En mode direct pour les paiements. in mode d'essai, aucune facturation réel n'est effectuée. Utilisez-le pour synchroniser le flux de réservation et de paiement. Passez en mode direct pour accepter les paiements actuels des clients.",
      "enable_coupon" : "Activez les codes de coupon",
      "enable_coupon_tooltip" : "Permettez aux clients d'appliquer des codes de coupon lors de la réservation. Pour vous assurer qu’ils fonctionnent, créez d’abord des Codes des coupons valides sous Paiement > Codes des coupons"
    },
    "notifications" : {
      "notifications" : "Notifications et options supplémentaires",
      "notifications_sub" : "Configure les notifications et les options supplémentaires",
      "edit" : "Modifier",
      "created_on" : "Créé le",
      "updated_on" : "Mise à jour le",
      "delivered" : "Livré",
      "not_available" : "S.O.",
      "select_notification_type" : "Sélectionne le type de notification",
      "notification_person" : "Qui devrait recevoir cette notification ?",
      "contact" : "{contactLabel}",
      "guest" : "Invité",
      "assigned_user" : "Utilisateur assigné",
      "emails" : "Courriels",
      "alert_email_address" : "Adresse courriel d’alerte",
      "ack_email" : "Courriel d’accusé de réception",
      "send_google_invites" : "Autoriser Google Agenda à envoyer des invitations ou à mettre à jour des courriels aux participants.",
      "send_google_outlook_invites" : "Autoriser Google / Outlook / iCloud Calendar à envoyer des courriels d'invitation et de mise à jour aux participants.",
      "assign_user_to_contact" : "Attribuer {contactsLabel} aux membres respectifs de leur équipe de calendrier à chaque fois qu’un rendez-vous est réservé",
      "skip_assigning_user_to_contact" : "Ignorer l’attribution de {contactLabel} si le {contactLabel} a déjà un utilisateur assigné",
      "assigned_staff" : "Personnel assigné",
      "additional_emails" : "Courriels supplémentaires",
      "assign_user_to_staff" : "Attribuer {contactsLabel} à leurs membres du personnel de service respectifs à chaque fois qu’un rendez-vous est réservé",
      "allow_cancellation" : " Autoriser l'annulation de la réunion",
      "allow_reschedule" : "Permettre de reprogrammer la réunion",
      "allow_cancellation_tooltip" : "Lorsqu'il est activé, un lien d'annulation sera ajouté à la section des notes supplémentaires et inclus dans l'invitation du calendrier. Ce lien expirera comme configuré avant l’heure de début de la réunion, empêchant le booker d’annuler la réunion.",
      "allow_reschedule_tooltip" : " Lorsqu'il est activé, un lien de reprogrammation sera ajouté à la section des notes supplémentaires et inclus dans l'invitation du calendrier. Ce lien expirera comme configuré avant l’heure de début de la réunion, empêchant le booker de reprogrammer la réunion.",
      "cancellation_link_expiry" : "Le lien d’annulation expirera",
      "reschedule_link_expiry" : "Le lien de reprogrammation expirera",
      "before_meeting" : "avant la réunion",
      "cancellation_and_reschedule_policy" : "Politique d'annulation et de report :",
      "meeting_invite_notes" : "Notes d'invitations à la conférence",
      "meeting_invite_notes_tooltip" : "Ajoutez des notes qui apparaîtront in l'invitation du calendrier envoyée aux clients. Ces notes seront synchronisées avec les calendriers des tiers in la Description de la conférence"
    },
    "connections" : {
      "connections_heading" : "Synchronisation du calendrier externe",
      "connections_sub" : "Synchronise les événements avec le calendrier externe",
      "link_to_calendar" : "Lien vers le calendrier",
      "sync_option" : "Option de synchronisation",
      "execute_automation" : "Exécuter l'automatisation",
      "fire_workflow" : "Déclencheurs de flux de travail pour les événements réservés via une synchronisation bidirectionnelle",
      "reserve_with_google" : "Réserver avec Google (pour être obsolète)",
      "reserve_with_google_setup" : "Voir les instructions de Config",
      "reserve_with_google_configure" : "Configurer",
      "change" : "Changement",
      "rwg_deprecation_notice" : "Google a <strong>obsolète avec Google (RwiG)</strong>, appelé <strong>des publicités Services locaux</strong>. Les nouveaux connexions sont plus pris en charge. Pour continuer à utiliser les réservations via Google, veuillez utiliser <strong>Google Organic Booking</strong> .",
      "rwg_category" : "Catégorie",
      "rwg_service_type" : "Service",
      "connect_lsa" : "Connectez-vous à ton compte de publicités de services locaux",
      "reserve_error" : "Actuellement, Reserve with Google est pris en charge uniquement pour « Home Services », « Real Estate », « Legal Services » (fournisseurs de services locaux) Company Niche aux États-Unis.",
      "one_way" : "Sens Unique",
      "two_way" : "Bidirectionnel",
      "smart" : "Intelligent",
      "confirm_remove" : "Êtes-vous sûr de vouloir supprimer Google Agenda ?",
      "read_only_access" : "Vous n'avez pas accès en écriture à ce calendrier. Veuillez sélectionner un autre calendrier.",
      "reserve_with_google_desc" : "Ce service de calendrier sera répertorié en réserve avec Google uniquement après une intégration réussie.",
      "check_integration" : "Vérifier l'état de votre intégration",
      "setup_external" : "Configurer votre calendrier externe",
      "reserve_price_decimal_error" : "Le prix décimal n’est pas pris en charge",
      "reserve_price_max_error" : "Prix pris en charge moins de 1000",
      "link_to_calendar_tooltip" : "Sélectionnez le calendrier avec lequel vous souhaitez synchroniser ce calendrier",
      "one_way_sync" : "Sens unique",
      "default_one_way" : "Synchronisation par défaut (synchronisation à sens unique)",
      "one_way_sync_desc" : "Les événements du calendrier lié sont synchronisés en tant que créneaux bloqués, et aucun contact n'est créé pour les invités.",
      "two_way_sync" : "Synchronisation bidirectionnelle",
      "two_way_sync_desc" : "Des contacts sont créés pour les invités trouvés dans les événements du calendrier lié, et ces événements sont transformés en rendez-vous système.",
      "smart_sync" : "Synchronisation Intelligente",
      "smart_sync_desc" : "Les événements du calendrier lié sont synchronisés en tant que rendez-vous pour les contacts existants. Si aucun contact n'existe, ils sont synchronisés en tant que créneaux bloqués sans créer de nouveau contact.",
      "sync_option_tooltip" : "Choisissez comment les événements de votre calendrier externe se synchronisent avec ce calendrier. Vous pouvez uniquement bloquer les disponibilités, ou également créer/gérer des {contactsLabel} et des rendez-vous ici — en fonction du mode de synchronisation sélectionné",
      "one_way_sync_tooltip" : "Bloquez des créneaux de Date via l’importation d’événements occupés de vos calendriers de tiers",
      "two_way_sync_tooltip" : "Importe les réunions et crée des {contactsLabel} ainsi que des rendez-vous dans le système. Les modifications apportées ici seront reflétées dans le calendrier externe",
      "smart_sync_tooltip" : "Importe les réunions et crée des rendez-vous seulement si la réunion a été créée par un {contactLabel} connu",
      "default_sync" : "Par défaut",
      "default_sync_desc" : "Synchronise les événements de votre calendrier externe vers ce calendrier",
      "advanced_sync" : "Avancé",
      "advanced_sync_desc" : "Synchronise les événements de votre calendrier externe avec ce calendrier et crée des contacts et des rendez-vous dans le système",
      "assign_contact_to" : "Attribuer un contact à",
      "select_calendar" : "Sélectionner le calendrier",
      "sync_preferences" : "Préférences de synchronisation",
      "sync_preferences_desc" : "Comment souhaitez-vous synchroniser les événements de votre calendrier connecté?",
      "recommended" : "Recommandé",
      "execute_automation_desc" : "Exécuter l'automatisation quand une Conférence est créée dans ce calendrier",
      "save" : "Enregistrer les modifications",
      "cancel" : "Annuler"
    },
    "extras" : {
      "extras" : "Personnalisations",
      "extras_sub" : "Définir le style du widget et d'autres préférences.",
      "calendar_widget_style" : "Style du widget de calendrier",
      "neo" : "Nouveau",
      "classic" : "Classique",
      "insert_custom_code" : "Insérer du code personnalisé",
      "show_seats_per_slot" : "Afficher les sièges par créneau",
      "allow_reschedule_meeting" : "Permettre de reprogrammer la réunion",
      "allow_cancelling_meeting" : "Autoriser l'annulation de la réunion",
      "additional_notes" : "Notes supplémentaires",
      "cancellation_and_reschedule" : "Annulation et report :",
      "allow_staff" : "Permets la sélection du personnel lors de la réservation",
      "code_block_tooltip" : "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la vie privée, la sécurité, les performances et le comportement de la page. Nous vous recommandons donc de vérifier le contenu de ce script avant de l'enregistrer dans le calendrier.",
      "calendar_image" : "Image de couverture de calendrier",
      "remove_image" : "Supprimer l'image",
      "calendar_image_info" : "L’image téléchargée sera visible dans le modèle Vue de groupe pour Neo et n’apparaîtra pas sur le lien du calendrier individuel",
      "get_image_from_unsplash" : "Améliorez vos visuels avec",
      "unsplash" : "Unsplash",
      "service_additional_preferences" : "Configurer des préférences supplémentaires",
      "service_image" : "Image de couverture du service",
      "service_image_description" : "Sélectionnez une image qui sera affichée dans le menu des services pour ce service",
      "allow_reschedule_appointment" : "Permettre de reprogrammer le rendez-vous",
      "allow_cancelling_appointment" : "Autoriser l'annulation du rendez-vous",
      "custom_code_placeholder" : "Veuillez saisir votre code personnalisé ici",
      "calendar_widget_style_desc" : "Choisissez entre notre widget classique ou l'élégant widget Neo",
      "seats_per_slot" : "Sièges par créneau",
      "show_staff_selection" : "Sélection du personnel",
      "seats_per_slot_desc" : " Permettez aux réservateurs de visualiser le nombre de places disponibles pour chaque créneau horaire directement sur le widget du calendrier.",
      "show_staff_selection_desc" : "Permettez aux réservateurs de choisir un membre du personnel directement à partir du widget de calendrier lors de la réservation de rendez-vous. Fonctionne uniquement avec le widget Neo",
      "widget_re_order_tooltip" : "Le style de widget classique ne permet pas de modifier l'ordre des widgets. Assurez-vous que le sélecteur de date et d'heure est en premier et que le formulaire est en deuxième avant de sélectionner le style classique.",
      "show_staff_selection_desc_service" : "Permettez aux réservateurs de choisir un membre du personnel directement à partir du widget de calendrier lors de la réservation de rendez-vous.",
      "switch_to_classic_widget" : "Passer au Widget Classique",
      "switch_to_classic_widget_desc" : "Envoyez un message direct au <b> Widgetclassique</b> désactivera automatiquement les participants, car ils ne peuvent pas coexister :",
      "form_first_disabled" : "<b>Le formulaire sera déplacé à la deuxième étape</b> in tri du Widget .",
      "appointment_preference_disabled" : "<b>Préférence pour les nouveaux rendez-vous (toujours réserver avec l'utilisateur assigné à {contactLabel})</b> sera désactivée. Cela signifie que les rendez-vous peuvent être réservés avec n’importe quel membre disponible de l'équipe, au lieu d’être limités à l’utilisateur assigné à {contactLabel}.",
      "multiple_location_disabled" : "<b>L'emplacement de plusieurs conférences</b> sera pris en charge et seul le <b>premier emplacement ajouté</b> sera sélectionné.",
      "insert_custom_code_tooltip" : "Personnaliser le style de Widget via votre propre Code CSS",
      "classic_tooltip_disabled" : "Le widget classique n'est pas pris en charge pour les calendriers de réservation de classe.",
      "show_staff_selection_disabled_tooltip" : "La sélection du personnel est prise en charge uniquement pour le widget neo"
    },
    "roomsAndEquipments" : {
      "title" : "Sélectionne les salles et les équipements",
      "description" : "Sélectionnez dans une liste de chambres et d’équipement ce qui sera réservé avec ce calendrier",
      "rooms" : "Sélectionnez les pièces",
      "equipments" : "Sélectionner l'équipement"
    }
  },
  "activity_log" : {
    "activity_log" : "Journal d'activité",
    "date" : "Date",
    "filter_by" : "Filtrer par",
    "calendar_update" : "Mise à jour du calendrier",
    "start_time_update" : "Mise à jour de l'heure de début",
    "end_time_update" : "Mise à jour de la fin des temps",
    "title_update" : "Mise à jour du titre",
    "notes_update" : "Mise à jour des notes",
    "appointment_status_update" : "Mise à jour du statut du rendez-vous",
    "meeting_location_update" : "Mise à jour sur le lieu de la réunion",
    "google_sync_update" : "Mise à jour de Google Sync",
    "outlook_sync_update" : "Mise à jour de la synchronisation Outlook",
    "assigned_user_update" : "Mise à jour de l'utilisateur assigné",
    "appointment_status" : "Statut du rendez-vous",
    "assigned_user" : "Utilisateur assigné",
    "uploaded_to" : "Téléversé sur",
    "cancelled" : "Annulé",
    "edited" : "édité",
    "other_edits" : "Autres modifications",
    "view_details" : "Voir les détails",
    "all" : "Tous"
  },
  "appointment_list" : {
    "group_all" : "TOUS",
    "group_primary" : "PRIMAIRE",
    "group_user" : "UTILISATEURS",
    "group_team" : "GROUPES",
    "group_calendar" : "CALENDRIERS",
    "all_appointments" : "Tous les rendez-vous",
    "my_calendar" : "Mon calendrier",
    "status_all" : "Tous",
    "status_confirmed" : "Confirmé",
    "status_new" : "Nouveau (action requise)",
    "status_show" : "Montré",
    "status_no_show" : "Absent",
    "status_cancelled" : "Annulé",
    "status_invalid" : "Invalide",
    "filter_date_added_desc" : "Date d’ajout (Desc)",
    "filter_start_added_desc" : "Date de début (Desc)",
    "filter_start_added_asc" : "Date de début décroissant à partir d'aujourd'hui",
    "button_new_appointment" : "Nouveau rendez-vous",
    "name" : "Nom",
    "title" : "Titre",
    "requested_time" : "Temps demandé",
    "date_added" : "Date d'ajout",
    "calendar" : "Calendrier",
    "appointment_owner" : "Propriétaire du rendez-vous",
    "notes" : "Notes",
    "status" : "Statut",
    "action_view_detail" : "Voir les détails",
    "action_view_consent" : "Voir le consentement",
    "action_view_notes" : "Voir les notes",
    "action_edit" : "Modifier",
    "action_delete" : "Supprimer",
    "action_reschedule" : "Rééchelonnement",
    "page_previous" : "Précédent",
    "page_next" : "Suivant",
    "appointment_notes" : "Notes de rendez-vous",
    "close" : "Fermer",
    "confirm_delete_header" : "Supprimer le rendez-vous",
    "confirm_delete_message" : "Êtes-vous sûr de vouloir supprimer ce rendez-vous ? Cette action ne peut pas être annulée !",
    "confirm_delete_button" : "Supprimer",
    "confirm_update_header" : "Mettre à jour le statut rendez-vous",
    "confirm_update_confirmed_message" : "Êtes-vous sûr de vouloir marquer ce rendez-vous comme confirmé?",
    "confirm_update_invalid_message" : "Êtes-vous sûr de vouloir marquer ce rendez-vous comme non valide?",
    "confirm_update_showed_message" : "Êtes-vous sûr de vouloir marquer ce rendez-vous comme présent?",
    "confirm_update_noshow_message" : "Êtes-vous sûr de vouloir marquer ce rendez-vous comme étant absent?",
    "confirm_update_cancelled_message" : "Êtes-vous sûr de vouloir marquer ce rendez-vous comme annulé?",
    "confirm_update_button" : "Mise à jour",
    "empty_state_title" : "Aucun rendez-vous trouvé",
    "empty_state_description" : "Aucun rendez-vous trouvé",
    "disable_menu_warning" : "Actuellement, vous n'avez pas la permission de voir ou de modifier les détails du rendez-vous, car le contact associé ne vous est pas assigné. Veuillez contacter votre administrateur pour obtenir de l'aide.",
    "no_contact_warning" : "Vous ne pouvez pas accéder aux coordonnées pour le moment. Cela peut être dû au fait que le contact ne vous est pas attribué. Veuillez communiquer avec votre administrateur pour obtenir de l'aide.",
    "consent_label" : "Consentement",
    "ip_address" : "PI",
    "youre_viewing_in" : "Actuellement en train de regarder dans",
    "appointment_delete_msg" : "<b>Attention :</b> le rendez-vous supprimé ici ne sera pas supprimé de calendly.",
    "rescheduled" : "Replanifié"
  },
  "add_guest" : {
    "guest_label" : "Invité(s)",
    "search_placeholder" : "Rechercher parmi les contacts",
    "add_new" : "Ajouter nouveau",
    "save" : "Enregistrer",
    "close" : "Fermer",
    "name" : "Nom",
    "phone" : "Téléphone",
    "email" : "Courriel",
    "guest_label_count" : "Nombre d'invités",
    "guest_count_error" : "Le nombre d'invités doit être compris entre 1 et 100"
  },
  "languages" : {
    "danish" : "Danish",
    "dutch" : "Dutch",
    "english" : "English",
    "finnish" : "Finnish",
    "french" : "French",
    "french_canada" : "French (Canada)",
    "german" : "German",
    "hungarian" : "Hungariam",
    "italian" : "Italian",
    "norwegian" : "Norwegian",
    "polish" : "Polish",
    "portuguese_brazil" : "Portuguese (Brazil)",
    "portuguese_portugal" : "Portuguese (Portugal)",
    "spanish" : "Spanish",
    "swedish" : "Swedish",
    "turkish" : "Turkish"
  },
  "service_menu_advanced" : {
    "new_service_menu_details_header" : "Détails du menu de service",
    "select_groups_header" : "Sélectionne des services",
    "arrange_groups_header" : "Arrange tes services",
    "new_service_menu" : "Nouveau menu de service",
    "service_menu_sub_title" : "Crée un menu de service personnalisé pour tes clients en quelques clics",
    "quick_tip" : "Vous pouvez ajouter des groupes au menu de service",
    "service_menu_name" : "Nom du menu de service",
    "service_menu_description" : "Description",
    "service_menu_slug" : "URL du service",
    "select_groups_calendars" : "Sélectionner des groupes et des calendriers",
    "select_groups_calendars_desc" : "Ajoute des services à ton menu de services",
    "select_all" : "Sélectionner tout",
    "arrange_groups" : "Organiser l’ordre des services",
    "arrange_groups_desc" : "Déterminer l'ordre des services dans le menu de service",
    "arrange_services_quicktip" : "Pour réorganiser les calendriers au sein d'un groupe, accédez à Groupes > Options > Réorganiser les calendriers.",
    "enable_add_guest_desc" : "Permet aux clients d'inclure des invités supplémentaires lors de la réservation.",
    "enable_multiple_service_desc" : "Permet aux clients de réserver plusieurs services en un seul rendez-vous.",
    "enable_staff_selection_desc" : "Permet aux clients de sélectionner les membres du personnel qu'ils préfèrent lorsqu'ils effectuent une réservation.",
    "enable_add_guest" : "Activer Ajouter des invités",
    "enable_multiple_service" : "Activer la sélection de plusieurs services",
    "enable_staff_selection" : "Activer la sélection du personnel",
    "additional_options" : "Options supplémentaires",
    "code_block_tooltip" : "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la vie privée, la sécurité, les performances et le comportement de la page. Par conséquent, nous vous recommandons de revoir le contenu de ce script avant de l'enregistrer dans le menu de service.",
    "custom_code_placeholder" : "Veuillez saisir votre code personnalisé ici",
    "insert_custom_code" : "Insérer du code personnalisé",
    "no_service" : "Aucun service trouvé",
    "no_service_desc" : " Aucun service trouvé. Créez des services et ajoutez-les à des groupes pour créer un menu de services.",
    "learn_more" : "En savoir plus",
    "no_service_selected" : "Aucun service sélectionné",
    "create_service_calendars" : "Créer des calendriers de service",
    "alert_description" : " Pour créer un menu de services, tu dois créer des calendriers de services et les ajouter à des groupes",
    "dont_show_again" : "Ne plus afficher cette adresse",
    "service_name_required" : "Le nom du menu de service est requis",
    "slug_already_taken" : "Ce slug est déjà pris",
    "slug_required" : "Le slug est requis",
    "please_enter_name" : "Veuillez saisir un nom",
    "service_name_placeholder" : "Menu principal",
    "service_slug_placeholder" : "menu principal",
    "form_label" : "Formulaire",
    "consent_label" : "Case à cocher de consentement",
    "consent_input_placeholder" : "Ajouter du texte de consentement",
    "consent_tooltip" : "Activez cette option pour permettre d’obtenir le consentement de {contactsLabel} quand ils fournissent leur numéro de téléphone lors du processus de réservation de rendez-vous.",
    "back_message" : "Retour à la Liste",
    "saving_changes" : "Une minute - Sauvegarder les cours de la dernière dynamique...",
    "payment_provider_warning" : "Attention! Les menus de service ne prennent actuellement en charge que les paiements par le biais de Stripe et Authorize.net. Étant donné que votre fournisseur par défaut est différent, les paiements activés pour les calendriers sélectionnés seront ignorés.",
    "aria" : {
      "consent_form_toggle" : "Bascule du formulaire de consentement",
      "enable_add_guest_toggle" : "Bascule d'activation de l'ajout d'un invité",
      "enable_multiple_services_toggle" : "Bascule d'activation de plusieurs services",
      "enable_staff_selection_toggle" : "Bascule d'activation de la sélection du personnel"
    }
  },
  "widget_configuration" : {
    "customise_calendar_widget" : "Personnalise le widget de calendrier",
    "works_with_neo_widget" : "Fonctionne uniquement avec le widget Neo",
    "customise_widget_desc" : "Personnaliser l'apparence du widget : couleur primaire, couleur de fond et texte du bouton.",
    "learn_more" : "En savoir plus",
    "primary_settings" : "Paramètres principaux",
    "primary_settings_desc" : "Configurez la couleur principale, la couleur d'arrière-plan et d'autres préférences de widget pour personnaliser votre widget de calendrier",
    "primary_color" : "Couleur primaire",
    "primary_color_desc" : "Définissez la couleur des boutons, des dates, des plages horaires et des actions",
    "background_color" : "Couleur d’arrière-plan",
    "background_color_desc" : "Définissez la couleur d'arrière-plan qui sert d'arrière-plan au sélecteur de date-heure et au formulaire.",
    "button_text" : "Texte du bouton",
    "button_text_desc" : "Personnalise le texte affiché sur le bouton lors de la prise de rendez-vous",
    "calendar_title" : "Titre du calendrier",
    "calendar_title_desc" : "Le nom de ton calendrier",
    "calendar_description" : "Description du calendrier",
    "calendar_description_desc" : "La description saisie",
    "calendar_details" : "Détails du calendrier",
    "calendar_details_desc" : "Inclut de l'information telle que la durée, la date et l'heure, les détails récurrents et le fuseau horaire",
    "reset_to_default" : "Réinitialiser aux paramètres par défaut",
    "preview_widget" : "Widget d’aperçu",
    "calendar_title_tooltip" : "Collection Si le Nom du calendrier et le Nom du groupe (si applicable) doivent être visibles Tous les Widget .",
    "calendar_description_tooltip" : "Collection Si la Description du calendrier doit être visible sur Tous les Widget .",
    "calendar_details_tooltip" : "Collection des informations sur les réunions, telles que",
    "insert_custom_code_tooltip" : "Personnaliser le style de Widget via votre propre Code CSS .",
    "staff_selection_tooltip" : "Réserver actif pour sélectionner un membre du personnel directement à partir du Widget de calendrier lors de la réservation de rendez-vous. Fonctionne uniquement avec Neo Widget."
  },
  "eventNotification" : {
    "customFields" : "Domaines Personnalisé",
    "customValues" : "Valeurs personnalisées",
    "guest" : "Invité",
    "assignedUser" : "Utilisateur assigné",
    "additionalEmails" : "Courriels supplémentaires",
    "list" : {
      "booked" : {
        "title" : "Rendez-vous Réservé (Statut: non confirmé)",
        "note" : "Cette Notification est envoyée lorsqu'un nouveau rendez-vous est créé avec un statut non confirmé.",
        "subTitle" : "Avertit lorsqu'un rendez-vous est réservé avec un statut non confirmé"
      },
      "confirmation" : {
        "title" : "Rendez-vous Réservé (Statut: Confirmé)",
        "note" : "Cette Notification est envoyée lorsqu'un rendez-vous est créé avec des mises à jour pour le statut.",
        "subTitle" : "Avise lorsqu’un rendez-vous est confirmé avec succès"
      },
      "cancellation" : {
        "title" : "Annulation",
        "note" : "Cette Notification est envoyée lorsqu’un rendez-vous est annulé, marqué comme non valide, ou marqué comme invalide.",
        "subTitle" : "Alertes lorsqu’un rendez-vous est annulé"
      },
      "reschedule" : {
        "title" : "Rééchelonnement",
        "note" : "Cette Notification est envoyée lorsqu’un rendez-vous est reporté. Il sera uniquement déclenché si le rendez-vous est in un statut non confirmé ou confirmé.",
        "subTitle" : "Notification en cas de report d'un rendez-vous"
      },
      "reminder" : {
        "title" : "Rappel",
        "note" : "Cette Notification est envoyée en tant qu'appel avant le rendez-vous. Il sera uniquement déclenché si le rendez-vous est in un statut non confirmé ou confirmé.",
        "subTitle" : "Envoie un rappel avant le rendez-vous"
      },
      "followup" : {
        "title" : "suivi",
        "note" : "Cette Notification est envoyée après le rendez-vous comme suivi. Il sera uniquement déclenché si le rendez-vous est in des non confirmés, confirmés, ou un mois de statut.",
        "subTitle" : "Envoi d'un message de suivi une fois le rendez-vous terminé"
      }
    },
    "saveToastMsg" : "Paramètres enregistrés!",
    "saveToastMsgDesc" : "Tes modifications ont été enregistrées avec succès",
    "enableSuccess" : "Notifications activées!",
    "disableSuccess" : "Notifications désactivées !",
    "tooltip" : "Cette Notification a été Handicapés. Veuillez l'activer pour créer tout dynamique.",
    "enabled" : "Activé",
    "disabled" : "Désactivé",
    "statusLabel" : "Étiquettes de Statut",
    "email" : {
      "channelName" : "Courriel",
      "noneTemplate" : "Aucun",
      "notificationLabel" : "Qui devrait recevoir cette notification ?",
      "sendButtonLabel" : "Envoyer un courriel de test",
      "testEmailLabel" : "Courriel de test",
      "testEmailPlaceholder" : "Entrez l'adresse courriel du destinataire pour tester",
      "body" : "Corps du courriel",
      "bodyPlaceholder" : "Tapez votre message ici",
      "subject" : "Sujet",
      "subjectPlaceholder" : "Saisissez l'objet du courriel",
      "templateLabel" : "Modèle de courriel",
      "templatePlaceholder" : "Sélectionnez un modèle de courriel ou commencez à partir de zéro",
      "fromNamePlaceholder" : "Saisis le nom",
      "fromNameLabel" : "De Nom",
      "fromAddressLabel" : "De Adresse",
      "alertEmailAddress" : "Saisissez des ID de courriel (Séparer via com)",
      "addMore" : "Ajouter plus",
      "afterAppointmentEnds" : "après la fin du rendez-vous",
      "beforeAppointmentStarts" : "avant que le rendez-vous commence",
      "durationLabel" : "Quand souhaitez-vous déclencher la notification?",
      "disableEmailNotification" : "Désactiver les notifications par courriel",
      "enableEmailNotification" : "Activer les notifications par courriel",
      "enableSuccess" : "Notification par courriel activée!",
      "enableSuccessDesc" : "Vous allez maintenant commencer à recevoir cette notification",
      "disableSuccess" : "Notification par courriel désactivée!",
      "disableSuccessDesc" : "Vous ne recevrez plus cette notification",
      "reset_to_default" : "Remise à zéro à par défaut",
      "testEmailSuccessTitle" : "Courriel de test envoyé!",
      "testEmailSuccessDesc" : "Le courriel de test a été envoyé à {email} avec succès",
      "testEmailErrorTitle" : "Échec de l'envoi du courriel de test",
      "testEmailErrorDesc" : "Une erreur s'est produite lors de l'envoi du courriel de test. Veuillez réessayer."
    },
    "inApp" : {
      "channelName" : "in-app",
      "title" : "Paramètres de notification",
      "enableInAppNotification" : "Activer in Notificationd'application",
      "disableInAppNotification" : "Désactiver in Notificationd'application",
      "selectedUser" : {
        "label" : "Envoyer à",
        "helperText" : "Cette notification interne est envoyée au moyen du Web et les applications mobiles.",
        "placeholder" : "Sélectionner un ou des utilisateurs"
      },
      "enableSuccess" : "Notifications intégrées à l'application activées!",
      "enableSuccessDesc" : "Vous allez maintenant commencer à recevoir cette notification",
      "disableSuccess" : "Notifications intégrées à l'application désactivées!",
      "disableSuccessDesc" : "Vous ne recevrez plus cette notification"
    },
    "sms" : {
      "channelName" : "SMS",
      "noneTemplate" : "Aucun",
      "notificationLabel" : "Qui devrait recevoir cette notification?",
      "sendButtonLabel" : "Envoyer un SMS test",
      "testSMSLabel" : "SMS test (entrez le numéro de téléphone avec l'indicatif du pays)",
      "testSMSPlaceholder" : "+12345678901",
      "body" : "SMS",
      "bodyPlaceholder" : "Tapez votre message SMS ici",
      "durationLabel" : "Quand voulez-vous déclencher la notification?",
      "disableSMSNotification" : "Désactiver les notifications par SMS",
      "enableSMSNotification" : "Activer les notifications par SMS",
      "enableSuccess" : "Notification par SMS activée!",
      "enableSuccessDesc" : "Vous recevrez désormais cette notification.",
      "disableSuccess" : "Notification par SMS désactivée!",
      "disableSuccessDesc" : "Vous ne recevrez plus cette notification.",
      "alertPhoneNumbers" : "Saisissez les numéros de téléphone (avec les indicatifs de pays, séparés par des virgules)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Ajouter plus",
      "afterAppointmentEnds" : "après la fin du rendez-vous",
      "beforeAppointmentStarts" : "avant le début du rendez-vous",
      "templateLabel" : "Modèle de SMS",
      "templatePlaceholder" : "Sélectionnez un modèle de SMS...",
      "reset_to_default" : "Réinitialiser aux paramètres par défaut",
      "testSmsSuccessTitle" : "SMS de test envoyé!",
      "testSmsSuccessDesc" : "Un SMS de test a été envoyé à {phone} avec succès",
      "testSmsErrorTitle" : "Échec de l'envoi du SMS de test",
      "testSmsErrorDesc" : "Une erreur s'est produite lors de l'envoi du SMS de test. Veuillez réessayer."
    },
    "whatsapp" : {
      "channelName" : "WhatsApp",
      "notificationLabel" : "Qui devrait recevoir cette notification?",
      "sendButtonLabel" : "Envoyer une notification WhatsApp d'essai",
      "testWhatsAppLabel" : "Tester la notification WhatsApp (entrez le numéro de téléphone avec l'indicatif du pays)",
      "testWhatsAppPlaceholder" : "+12345678901",
      "durationLabel" : "Quand voulez-vous déclencher la notification?",
      "alertPhoneNumbers" : "Saisissez les numéros de téléphone (avec les indicatifs de pays, séparés par des virgules)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Ajouter plus",
      "afterAppointmentEnds" : "après la fin du rendez-vous",
      "beforeAppointmentStarts" : "avant le début du rendez-vous",
      "templateLabel" : "Modèle WhatsApp",
      "templatePlaceholder" : "Sélectionner le modèle WhatsApp…",
      "noPreview" : "Aucun modèle sélectionné",
      "templateRequired" : "Modèle obligatoire",
      "testWhatsAppSuccessTitle" : "Notification WhatsApp d'essai envoyée!",
      "testWhatsAppSuccessDesc" : "La notification WhatsApp d'essai a été envoyée avec succès à {phone}.",
      "testWhatsAppErrorTitle" : "L'envoi de la notification WhatsApp d'essai a échoué.",
      "testWhatsAppErrorDesc" : "Une erreur s'est produite lors de l'envoi de la notification WhatsApp d'essai. Veuillez réessayer.",
      "setupTitle" : "Contactez votre Client sur son Application de messagerie préférée",
      "setupDescription" : "Restez plus proche de vos clients en fournissant une assistance instantanée, en envoyant des mises à jour opportunes et en créant des interactions engageantes.",
      "connectWhatsApp" : "Connectez WhatsApp",
      "checkingStatus" : "Vérification du statut du compte WhatsApp...",
      "checkingTemplateStatus" : "Vérification du statut du modèle WhatsApp...",
      "statusCheckError" : "Échec de la vérification de l'état du compte WhatsApp",
      "templateStatusCheckError" : "Échec de la vérification de l'état du modèle WhatsApp",
      "setupTemplateTitle" : "Complétez la configuration de votre modèle WhatsApp",
      "setupTemplateDescription" : "Vous devez configurer les modèles WhatsApp avant de pouvoir envoyer des notifications. Cliquez ci-dessous pour terminer le processus de configuration.",
      "loadTemplatesError" : "Échec du chargement des modèles WhatsApp",
      "templatesRefreshed" : "Modèles actualisés avec succès",
      "templatesRefreshError" : "Échec de l’actualisation des modèles",
      "templatesResolveError" : "Erreur lors de la résolution des modèles par défaut de WhatsApp",
      "locationNotFound" : "ID de l'emplacement non trouvé",
      "settingsRedirectError" : "Impossible de rediriger vers les paramètres WhatsApp",
      "updateNotificationError" : "Échec de la mise à jour de la notification WhatsApp",
      "notificationsEnabled" : "Notification WhatsApp activée!",
      "notificationsDisabled" : "Notifications WhatsApp désactivées!",
      "updateError" : "Erreur lors de la mise à jour des notifications",
      "createNewTemplate" : "Créer un nouveau modèle WhatsApp",
      "phoneValidation" : {
        "countryCodeRequired" : "Le numéro de téléphone doit commencer par un indicatif pays (par exemple, +1, +91, +44)",
        "digitsOnly" : "Le numéro de téléphone doit contenir uniquement des chiffres après l’indicatif pays",
        "tooShort" : "Le numéro de téléphone est trop court",
        "tooLong" : "Le numéro de téléphone est trop long",
        "invalid" : "Numéro de téléphone invalide"
      },
      "errors" : {
        "templateNotFound" : "ID du modèle non trouvé dans les options chargées, suppression",
        "templateNoLongerValid" : "Le modèle enregistré n'est plus valide, suppression",
        "invalidTemplateSelection" : "Tentative de sélection d'un modèle WhatsApp non valide",
        "fetchingTemplates" : "Erreur lors de la récupération des modèles WhatsApp",
        "mountingCreator" : "Erreur lors du montage du créateur de modèles WhatsApp",
        "fetchingAfterCreation" : "Erreur lors de la récupération des modèles WhatsApp après leur création",
        "updateStatus" : "Erreur lors de la mise à jour du statut WhatsApp"
      },
      "receiverLabels" : {
        "assignedUser" : "Utilisateur assigné",
        "phoneNumbers" : "Numéros de téléphone additionnels"
      }
    }
  },
  "smsTemplate" : {
    "create_new_template" : "Créer un nouveau modèle de SMS",
    "create_new_template_desc" : "Créer un modèle de SMS réutilisable pour vos notifications",
    "template_name" : "Nom du modèle",
    "template_name_placeholder" : "Entrez le nom du modèle",
    "message" : "Message",
    "message_placeholder" : "Tapez votre message SMS ici",
    "create_template" : "Créer un modèle",
    "name_required" : "Le nom du modèle est obligatoire",
    "text_required" : "Le texte du message est obligatoire",
    "fetch_new_templates" : "Actualiser les modèles"
  },
  "whatsappTemplate" : {
    "create_new_template" : "Créer un nouveau modèle WhatsApp",
    "create_new_template_desc" : "Créez un modèle WhatsApp réutilisable pour vos notifications.",
    "template_name" : "Nom du modèle",
    "template_name_placeholder" : "Saisissez le nom du modèle.",
    "message" : "Message",
    "message_placeholder" : "Tapez votre message WhatsApp ici.",
    "create_template" : "Créer un modèle",
    "name_required" : "Le nom du modèle est obligatoire.",
    "text_required" : "Le texte du message est obligatoire",
    "fetch_new_templates" : "Actualiser les modèles"
  },
  "archivedServices" : {
    "servicesBanner" : "Une nouvelle Version de Services est ici- plus puissante, plus flexible et plus ouvert. Vos calendriers de service ont déjà été migré. Découvrez-les maintenant in l’onglet Services .",
    "archivedServiceCalendars" : "Calendriers des services (v1)",
    "check_new_services" : "Case à cocher de nouveaux Services"
  },
  "tour" : {
    "hidden_test_label" : "Essai",
    "calendar" : {
      "edit_calendar" : "Modifier le calendrier",
      "share_calendar" : "Partager le calendrier",
      "troubleshoot_calendar" : "Dépannage le calendrier",
      "more_options" : "Plus d’options",
      "edit_calendar_desc" : "Personnalisez les paramètres du calendrier : Fixe, Configurer des appels de service, Modifier les limitations de rendez-vous et plus.",
      "share_calendar_desc" : "Copiez et partagez votre lien de programmation pour que Réserver peut facilement être réparti avec vous.",
      "troubleshoot_calendar_desc" : "Découvrez pourquoi un créneau ne s’affiche pas et consultez les raisons potentielles dans la vue de dépannage.",
      "more_options_desc" : "Accédez à des options supplémentaires et à des activités pour gérer votre calendrier.",
      "read_permissions" : {
        "share_description" : "Accordez l'accès aux autres en partageant le lien du calendrier ou en ajustant les autorisations.",
        "troubleshoot_description" : "Identifier et résoudre les problèmes tels que les erreurs de synchronisation ou les occurrences manquantes pour assurer un fonctionnement fluide."
      },
      "next" : "Suivant",
      "start_over" : "Début par",
      "all_set" : "Tout la Collection!",
      "previous" : "Précédent"
    }
  },
  "emailTemplate" : {
    "select_editing_experience" : "Sélectionner votre expérience d’édition",
    "select_editing_experience_desc" : "Personnaliser la création via notre code de glisser-déposer",
    "design_editor" : "Éditeur de conception",
    "design_editor_desc" : "Édition visuellement, Traîner -déposer.",
    "code_editor" : "Éditeur de code",
    "code_editor_desc" : "Personnalise la modification HTML .",
    "text_editor" : "Code d’éditeur",
    "text_editor_desc" : "Modifier le corps de l'édition.",
    "email_text_block" : "Le courriel peut également être créé via le Bloquer corps. ",
    "select" : "Sélectionner",
    "new_template" : "Nouveau Modèle",
    "email_block" : "Le courriel peut également être créé via le Bloquer corps.",
    "fetch_new_templates" : "Récupérer de nouveaux modèles"
  },
  "quick_tips" : {
    "meeting_details" : {
      "include_contact_and_user_names" : "Pour inclure à la fois le nom du contact et le nom de l'utilisateur du rendez-vous dans le titre de la réunion, utilisez le format suivant : &#123;&#123;contact.name&#125;&#125; X &#123;&#123;appointment.user.name&#125;&#125;",
      "add_backup_meeting_url" : "Pour garantir un accès ininterrompu, ajoutez une URL de réunion personnalisée comme option de secours en cas de problème avec les intégrations Zoom ou Gmeet.",
      "enable_gmeet_primary" : "Pour activer la fonctionnalité Gmeet, assurez-vous que le Google Agenda du membre du groupe est défini comme calendrier principale dans la configuration."
    },
    "availability" : {
      "twenty_four_hours" : "Pour rendre le calendrier disponible 24 heures/24, définissez la période de 12 AM à 12 AM.",
      "update_timezone_preferences" : "Les fuseaux horaires peuvent être modifiés à tout moment sous Profil de l'entreprise >> Préférences de fuseau horaire.",
      "service_calendar_slot_interval" : "Définissez la disponibilité de votre calendrier de service, avec un intervalle par défaut de 15 minutes entre les rendez-vous."
    },
    "forms" : {
      "create_custom_forms" : "Créez facilement des formulaires personnalisé dans la section Marketing sous « Formulaires » et intégrez-les sans effort dans les calendriers pour une collection de statistiques organisée.",
      "apply_sticky_contacts" : "Quand vous ajoutez un formulaire personnalisé, les configurations de contacts collants liés au formulaire seront appliqués automatiquement.",
      "use_custom_values" : "Vous avez la possibilité d'inclure des valeurs personnalisées et des champs de contacts à la fois dans le message du formulaire et dans l'URL du formulaire."
    },
    "notifications" : {
      "use_workflows" : "Pour les notifications avancées, utilisez les flux de travail ou les déclencheurs de rendez-vous réservé."
    },
    "customizations" : {
      "update_widget_language" : "Pour modifier les paramètres de langue du widget, suivez ces étapes : Configuration >> Calendriers >> Préférences >> Préférences du compte."
    },
    "equipments" : {
      "room_definition" : "Une « pièce » peut représenter tout emplacement où les services sont fournis. Cela peut être des pièces physiques ou des stations dédiées. Par exemple : station de pédicure.",
      "equipment_definition" : "Pensez à l'« équipement » comme tout outil ou appareil que les entreprises utilisent pour honorer les rendez-vous. Cela peut inclure des machines, des appareils ou même des sièges."
    }
  },
  "aria_labels" : {
    "sticky_contacts" : "Contacts collants",
    "consent_form" : "Formulaire de consentement",
    "enable_guests" : "Activer les invités",
    "auto_confirm" : "Confirmation automatique",
    "should_accept_payment" : "Devrait accepter le paiement",
    "collect_deposit" : "Collecte dépôt",
    "enable_charge_guests" : "Activer la facturation des invités",
    "enable_coupon" : "Activer le coupon",
    "payment_live" : "Paiement en direct",
    "add_availability_hour" : "Ajouter une heure de disponibilité",
    "remove_availability_hour" : "Supprimer l’heure de disponibilité",
    "copy_availability_hour" : "Copier l'heure de disponibilité",
    "close_modal" : "Fermer la fenêtre modale",
    "add_custom_slot" : "Ajouter un créneau personnalisé",
    "remove_custom_slot" : "Supprimer le créneau personnalisé",
    "edit_custom_slot" : "Modifier le créneau personnalisé",
    "update_frequency" : "Fréquence de mise à jour",
    "show_calendar_title" : "Afficher le titre du calendrier",
    "show_calendar_description" : "Afficher la description du calendrier",
    "show_calendar_details" : "Afficher les détails du calendrier",
    "allow_reschedule" : "Autoriser le report",
    "allow_cancellation" : "Autoriser l'annulation",
    "category_actions" : "Activités de catégories"
  },
  "placeholders" : {
    "pixel_id" : "ID du pixel",
    "select_one" : "Sélectionnez-en un.",
    "meeting_location" : "Emplacement de réunion",
    "schedule_meeting" : "Planifier une réunion",
    "notes" : "Notes",
    "select_users" : "Sélectionner des utilisateurs"
  },
  "alt_text" : {
    "payment_provider" : "Fournisseur de paiement",
    "no_calendars" : "Aucun calendrier",
    "date_specific_hours" : "heures spécifiques à la date",
    "custom_widget_image" : "Image du widget personnalisé",
    "service_calendar" : "Calendrier des services",
    "event_calendar" : "Calendrier des événements",
    "round_robin_booking" : "Réservation en tour de table",
    "class_booking" : "Réservation de cours",
    "collective_booking" : "Réservation collective"
  },
  "tooltips" : {
    "text_color" : "Couleur du texte",
    "background_color" : "Couleur d'arrière-plan",
    "strikethrough" : "Barré",
    "superscript" : "Exposant",
    "subscript" : "Indice",
    "inline_code_block" : "Bloc de code en ligne",
    "code_block" : "Bloc de code",
    "block_quote" : "Citation en bloc",
    "more" : "Plus",
    "upload" : "Téléverser"
  },
  "labels" : {
    "reset_style" : "Remise à zéro du style",
    "reset_document_style" : "Remise à zéro du style du document",
    "source_code" : "Code source",
    "success" : "Succès",
    "edit" : "Modifier",
    "submit" : "Soumettre",
    "cancel" : "Annuler",
    "payment" : "Paiement",
    "here_is_the_link" : "Voici le lien :",
    "here_is_the_embed_code" : "Voici le code d'intégration :",
    "service_calendar" : "Calendrier des services",
    "collective_booking" : "Réservation collective",
    "class_booking" : "Réservation de cours",
    "round_robin_booking" : "Réservation en tour de table",
    "event_calendar" : "Calendrier des événements",
    "personal_booking" : "Réservation personnelle",
    "service_booking" : "Réservation de services"
  },
  "validation_messages" : {
    "calendar_group_name_required" : "Le nom du groupe de calendrier est obligatoire.",
    "calendar_group_description_required" : "La description du groupe de calendrier est obligatoire.",
    "slug_required" : "Le slug est obligatoire.",
    "slug_not_valid" : "Ce slug n'est pas valide.",
    "slug_already_taken" : "Ce slug est déjà pris.",
    "error_validating_slug" : "Une erreur s'est produite lors de la validation du slug.",
    "please_enter_name" : "Veuillez saisir un nom.",
    "room_name_required" : "Le nom de la pièce est obligatoire.",
    "equipment_name_required" : "Le nom de l'équipement est obligatoire.",
    "subject_required" : "Le thème est obligatoire.",
    "this_is_required" : "Ceci est obligatoire.",
    "calendar_group_slug_required" : "L’identifiant du groupe de calendrier est requis",
    "capacity_mandatory" : "La capacité est obligatoire",
    "capacity_cannot_be_zero" : "La capacité ne peut pas être zéro",
    "capacity_should_be_a_number" : "La capacité doit être un nombre",
    "capacity_cannot_be_negative" : "La capacité ne peut pas être négative",
    "capacity_should_be_a_whole_number" : "La capacité doit être un nombre entier",
    "quantity_mandatory" : "La quantité est obligatoire",
    "quantity_cannot_be_zero" : "La quantité ne peut pas être zéro",
    "quantity_should_be_a_number" : "La quantité doit être un nombre",
    "quantity_cannot_be_negative" : "La quantité ne peut pas être négative",
    "quantity_should_be_a_whole_number" : "La quantité doit être un nombre entier.",
    "quantity_cannot_be_less_than_out_of_service_equipments" : "La quantité ne peut pas être moins que le nombre d'équipements hors service.",
    "out_of_service_value_should_be_a_number" : "La valeur hors service doit être un nombre",
    "out_of_service_cannot_be_negative" : "La valeur hors service ne peut pas être négative",
    "out_of_service_equipments_qty" : "Les équipements hors service ne peuvent pas dépasser la quantité réelle d’équipements",
    "out_of_service_whole_number" : "La valeur hors service doit être un nombre entier",
    "slot_duration_required" : "Une durée du créneau est obligatoire",
    "slot_duration_integer" : "La durée du créneau doit être un nombre entier",
    "meeting_duration_validation" : "La durée de la réunion doit être comprise entre 1 min et 12 heures",
    "seats_class_required" : "Le nombre de sièges par classe est requis.",
    "seats_class_integer" : "Le nombre de sièges par classe doit être un nombre entier",
    "seats_class_validation" : "Ceci ne peut pas être supérieur à 9999 ou inférieur à 0",
    "meeting_location_required" : "Le lieu de la réunion est requis"
  },
  "custom_values" : {
    "assigned_user" : "Utilisateur assigné",
    "full_name" : "Nom complet",
    "first_name" : "Prénom",
    "last_name" : "Nom de famille",
    "email" : "Courriel",
    "phone" : "Téléphone",
    "twilio_phone" : "Téléphone Twilio",
    "account" : "Compte",
    "name" : "Nom",
    "full_address" : "Adresse complète",
    "city" : "Ville",
    "state" : "État/Province",
    "country" : "Pays",
    "postal_code" : "Code postal",
    "contact" : "Contact",
    "address1" : "Adresse 1",
    "timezone" : "Fuseau horaire",
    "user" : "Utilisateur",
    "appointment" : "Rendez-vous",
    "start_date_time" : "Date et heure de début",
    "start_date" : "Date de début",
    "start_time" : "Heure de début",
    "end_date_time" : "Date et heure de fin",
    "end_date" : "Date de fin",
    "end_time" : "Heure de fin",
    "meeting_location" : "Emplacement de réunion"
  },
  "meeting_location_types" : {
    "zoom" : "Zoom",
    "google_meet" : "Google Meet",
    "phone" : "Téléphone",
    "full_address" : "Adresse complète",
    "microsoft_teams" : "Microsoft Teams",
    "custom" : "Personnalisé"
  },
  "duration_units" : {
    "minutes" : "Minutes",
    "hours" : "Heures"
  },
  "widget_styles" : {
    "classic" : "Classique",
    "neo" : "Neo"
  },
  "feature_labels" : {
    "service_menu" : "Menu de services",
    "rooms" : "Pièces",
    "equipments" : "Équipements"
  },
  "lsa" : {
    "categories" : {
      "accountant" : "Comptabilité",
      "acupuncturist" : "Acupuncture",
      "air_duct_cleaner" : "Nettoyage des conduits d'air",
      "alcohol_treatment" : "Services de traitement de l'alcoolisme",
      "animal_shelter" : "Services de sauvetage des animaux",
      "appliance_repair" : "Réparation d'appareils",
      "architect" : "Architecture",
      "assisted_living" : "Services d'assistance à la vie autonome",
      "babysitter" : "Garde d'enfants",
      "bankruptcy_lawyer" : "Droit de la faillite",
      "beauty_school" : "École de beauté",
      "business_lawyer" : "Droit des entreprises",
      "car_repair" : "Services automobiles",
      "carpenter" : "Menuiserie",
      "carpet_cleaning" : "Nettoyage de tapis",
      "child_care" : "Services de garde d'enfants",
      "chiropractor" : "Services de chiropratique",
      "cleaning_service" : "Service de nettoyage à domicile",
      "contract_lawyer" : "Droit contractuel",
      "countertop_pro" : "Services de comptoir",
      "criminal_lawyer" : "Droit pénal",
      "dance_instructor" : "Enseignement de la danse",
      "disability_lawyer" : "Droit des personnes handicapées",
      "driving_instructor" : "Enseignement de la conduite",
      "dui_lawyer" : "Législation sur la conduite avec facultés affaiblies",
      "electrician" : "Électrique",
      "energy_efficiency_pro" : "Services d'efficacité énergétique",
      "estate_lawyer" : "Droit successoral",
      "event_planner" : "Planification des événements",
      "family_lawyer" : "Droit de la famille",
      "fencing_pro" : "Clôturage",
      "financial_planner" : "Planification financière",
      "first_aid_trainer" : "Formation aux premiers secours",
      "flooring_pro" : "Revêtement de sol",
      "foundation_pro" : "Fondations",
      "funeral_home" : "Services funéraires",
      "garage_door_pro" : "Porte de garage",
      "general_contractor" : "Amélioration domiciliaire",
      "handyman" : "Homme à tout faire",
      "home_inspector" : "Inspection résidentielle",
      "home_security" : "Services de sécurité résidentielle",
      "home_theater" : "Services de cinéma à domicile",
      "hvac" : "CVC",
      "immigration_lawyer" : "Droit de l'immigration",
      "interior_designer" : "Stylisme d'intérieur",
      "ip_lawyer" : "Droit de la propriété intellectuelle",
      "junk_removal" : "Enlèvement des déchets",
      "labor_lawyer" : "Droit du travail",
      "landscaper" : "Aménagement paysager",
      "language_instructor" : "Enseignement des langues",
      "lawn_care" : "Entretien de la pelouse",
      "litigation_lawyer" : "Droit des litiges",
      "locksmith" : "Serrurier",
      "malpractice_lawyer" : "Droit de la faute professionnelle",
      "massage_center" : "Services de massage",
      "massage_school" : "École de massage",
      "mover" : "Déménagement",
      "nursing_home" : "Service de maison de soins infirmiers",
      "painter" : "Peinture",
      "personal_injury_lawyer" : "Droit des préjudices corporels",
      "personal_trainer" : "Entraînement personnel",
      "pest_control" : "Contrôle des nuisibles",
      "pet_adoption" : "Services d'adoption d'animaux de compagnie",
      "pet_boarding" : "Pension pour animaux",
      "pet_grooming" : "Toilettage pour animaux de compagnie",
      "pet_trainer" : "Dressage des animaux de compagnie",
      "photographer" : "Photographie",
      "plumber" : "Plomberie",
      "pool_cleaner" : "Nettoyage de piscine",
      "pool_contractor" : "Construction de piscines",
      "preschool" : "Préscolarisation",
      "psychologist" : "Services de psychologie",
      "real_estate_agent" : "Immobilier",
      "real_estate_lawyer" : "Droit immobilier",
      "rehab" : "Services de réadaptation",
      "roofer" : "Toiture",
      "sewage_pro" : "Services du système d'égouts",
      "siding_pro" : "Revêtement",
      "smart_home" : "Services de maison intelligente",
      "snow_removal" : "Services de déneigement",
      "spa" : "Services de spa",
      "tax_lawyer" : "Droit fiscal",
      "tax_specialist" : "Services fiscaux",
      "therapist" : "Thérapie",
      "towing_pro" : "Assistance routière",
      "traffic_lawyer" : "Code de la route",
      "tree_service" : "Services d'entretien des arbres",
      "tutor" : "Tutorat",
      "upholstery_cleaner" : "Nettoyage de tissus d'ameublement",
      "veterinarian" : "Services vétérinaires",
      "videographer" : "Services vidéo",
      "water_damage" : "Services de dégâts des eaux",
      "weight_loss_service" : "Services de perte de poids",
      "window_cleaner" : "Nettoyage de fenêtres",
      "window_repair" : "Services de fenêtres",
      "windshield_repair_pro" : "Vitres d'auto",
      "yoga_instructor" : "Yoga"
    },
    "job_types" : {
      "accountant_other" : "Autre",
      "bankruptcy_tax_litigation" : "Litige fiscal en matière de faillite",
      "bookkeeping" : "Tenue de comptabilité",
      "business_consulting" : "Conseil en entreprise",
      "debt_collection_relief" : "Recouvrement de créances",
      "irs_representation_resolution" : "Représentation et résolution de l'IRS",
      "payroll" : "Paie",
      "tax_planning_business" : "Planification fiscale entreprise",
      "tax_planning_individual" : "Planification fiscale particulier",
      "tax_return_business" : "Déclaration de revenus entreprise",
      "tax_return_individual" : "Déclaration de revenus particulier",
      "trusts_estates_accounting" : "Comptabilité des fiducies et successions",
      "acupressure" : "Acupression",
      "acupuncture" : "Acupuncture",
      "acupuncturist_other" : "Autre",
      "cupping" : "Ventouses",
      "gua_sha" : "Gua Sha",
      "heat_therapy" : "Thermothérapie",
      "herbal_therapy" : "Thérapie à base de plantes",
      "infrared_therapy" : "Thérapie infrarouge",
      "moxibustion" : "Moxibustion",
      "qigong" : "Qigong",
      "shiatsu" : "Shiatsu",
      "tui_na" : "Tui Na",
      "air_duct_cleaning" : "Nettoyage des conduits d'air",
      "air_duct_filter_replacement" : "Remplacement du filtre",
      "air_duct_other" : "Autre",
      "dryer_vent_cleaning" : "Nettoyage de la ventilation de la sécheuse",
      "furnace_cleaning" : "Nettoyage de fournaise",
      "indoor_air_quality_testing" : "Test de la qualité de l'air intérieur",
      "alcohol_treatment_other" : "Autre",
      "animal_shelter_cat_adoption" : "Adoption de chats",
      "animal_shelter_dog_adoption" : "Adoption de chiens",
      "animal_shelter_other" : "Autre",
      "animal_shelter_other_animal_adoption" : "Autres adoptions d'animaux",
      "animal_shelter_other_veterinary_services" : "Autres services vétérinaires",
      "animal_shelter_spay_neuter" : "Stérilisation ou castration",
      "animal_shelter_vaccinations" : "Vaccinations",
      "lost_stray_found_animals" : "Animaux perdus, errants ou trouvés",
      "pet_license" : "Permis pour animaux de compagnie",
      "pet_surrender" : "Abandon d'un animal de compagnie",
      "appliance_other" : "Autre",
      "repair_dishwasher" : "Réparation de lave-vaisselle",
      "repair_dryer" : "Réparer de la sécheuse",
      "repair_freezer" : "Réparation du congélateur",
      "repair_microwave" : "Réparation du micro-ondes",
      "repair_oven" : "Réparation du four",
      "repair_refrigerator" : "Réparation du réfrigérateur",
      "repair_refrigerator_freezer" : "Réparation du réfrigérateur/congélateur",
      "repair_stove_cooktop" : "Réparation de la cuisinière / plaque de cuisson",
      "repair_stove_cooktop_oven" : "Réparation de la cuisinière / de la plaque de cuisson / du four",
      "repair_washer" : "Réparation de la laveuse",
      "repair_washer_dryer" : "Réparation de la laveuse/sécheuse",
      "3d_architectural_rendering" : "Rendu architectural 3D",
      "adaptive_reuse_historical_renovation" : "Réutilisation adaptative et rénovation historique",
      "architect_other" : "Autre",
      "architectural_designing" : "Conception architecturale",
      "architectural_engineering" : "Ingénierie architecturale",
      "building_code_analysis_permit_coordination" : "Analyse du code et des permis",
      "consulting" : "Consultation",
      "home_building_improvement" : "Construction et amélioration domiciliaire",
      "interior_design_architect" : "Stylisme d'intérieur",
      "planning_zoning_approval_assistance" : "Approbation de la planification et du zonage",
      "project_managing_architect" : "Gestion de projet",
      "site_master_planning" : "Planification de base de l'emplacement",
      "assisted_living_housekeeping_and_laundry" : "Entretien ménager et blanchisserie",
      "assisted_living_meal_services" : "Services de repas",
      "assisted_living_memory_care" : "Soins de la mémoire",
      "assisted_living_other" : "Autre",
      "assisted_living_rehabilitation_services" : "Services de réadaptation",
      "assisted_living_transportation" : "Transport",
      "assisted_living_wellness_programs" : "Programmes de bien-être",
      "daily_living_assistance" : "Aide à la vie quotidienne",
      "medication_management" : "Gestion des médicaments",
      "short_term_stays" : "Séjours de courte durée",
      "social_and_recreational_activities" : "Activités récréatives",
      "babysitter_other" : "Autre",
      "event_babysitting" : "Garde d'enfants lors d'événements",
      "homework_assistance" : "Assistance aux devoirs",
      "housekeeping_laundry" : "Entretien ménager et blanchisserie",
      "meal_preparation" : "Préparation des repas",
      "nanny_services" : "Services de bonnes d'enfants",
      "overnight_babysitting" : "Garde d'enfants de nuit",
      "pick_up_and_drop_off" : "Ramassage et dépôt",
      "shopping_errand" : "Achats et courses",
      "special_needs_care" : "Soins pour besoins spéciaux",
      "virtual_babysitting" : "Garde d'enfants virtuelle",
      "agriculture_bankruptcy" : "Faillite agricole",
      "bankruptcy_lawyer_other" : "Autre",
      "bankruptcy_litigation" : "Litige en matière de faillite",
      "chapter_11_bankruptcy" : "Faillite en vertu du chapitre onzième",
      "chapter_13_bankruptcy" : "Faillite en vertu du chapitre treizième",
      "chapter_7_bankruptcy" : "Faillite en vertu du chapitre septième",
      "corporate_bankruptcy" : "Faillite d'entreprise",
      "creditor_harassment" : "Harcèlement des créanciers",
      "debt_settlement" : "Règlement des dettes",
      "foreclosure_bankruptcy_lawyer" : "Saisie immobilière",
      "personal_bankruptcy" : "Faillite personnelle",
      "repossession" : "Reprise de possession",
      "wage_garnishment" : "Saisie sur salaire",
      "beauty_school_barbering" : "Barbier",
      "beauty_school_business_management" : "Gestion des entreprises",
      "beauty_school_cosmetology" : "Cosmétologie",
      "beauty_school_esthetics" : "Esthétique",
      "beauty_school_hair_cutting" : "Coupe de cheveux",
      "beauty_school_hair_design" : "Coiffure",
      "beauty_school_makeup" : "Maquillage",
      "beauty_school_massage_therapy" : "Massothérapie",
      "beauty_school_nail_technology" : "Technologie des ongles",
      "beauty_school_other" : "Autre",
      "beauty_school_retail_training" : "Formation au commerce de détail",
      "banking_finance_law" : "Banque et finances",
      "business_lawyer_other" : "Autre",
      "business_licenses_permits" : "Licences et permis d'entreprise",
      "business_litigation" : "Litige d'entreprise",
      "business_taxes" : "Taxes sur les entreprises",
      "business_transactions_business_lawyer" : "Transactions commerciales",
      "commercial_bankruptcy" : "Faillite commerciale",
      "commercial_contracts_business_lawyer" : "Contrats commerciaux",
      "employment_law_business_lawyer" : "Droit du travail",
      "incorporation_restructuring" : "Incorporation et restructuration",
      "insurance_law" : "Droit des assurances",
      "intellectual_property_law" : "Droit de la propriété intellectuelle",
      "mergers_acquisitions_business_lawyer" : "Fusions et acquisitions",
      "partnership_agreements_business_lawyer" : "Accords de partenariat",
      "patents_copyrights_trademarks" : "Brevets, droits d’auteur et marques de commerce",
      "securities_law" : "Droit des valeurs mobilières",
      "shareholder_disputes" : "Litiges entre actionnaires",
      "air_and_cabin_filter" : "Filtre à air et d'habitacle",
      "battery" : "Batterie",
      "body_and_trim" : "Carrosserie et garniture",
      "brakes" : "Freins",
      "car_air_conditioning" : "Climatisation",
      "car_electrical" : "Appareils électrique",
      "car_repair_other" : "Autre",
      "check_engine_light_diagnostic" : "Diagnostic du voyant de contrôle du moteur",
      "exhaust" : "Échappement",
      "oil_change" : "Changement d’huile",
      "steering_suspension" : "Direction / Suspension",
      "tires" : "Pneus",
      "transmission" : "Transmission",
      "cabinetry" : "Aménagement de cabine",
      "carpenter_other" : "Autre",
      "decking" : "Décoration",
      "drywalling" : "Cloisons sèches",
      "fencing" : "Clôturage",
      "general_installations" : "Installations générales",
      "general_repairs_maintenance" : "Réparations générales et entretien",
      "remodeling" : "Rénovation",
      "shelving_storage" : "Rayonnage et stockage",
      "carpet_cleaning_other" : "Autre",
      "clean_area_rugs" : "Nettoyage de tapis",
      "clean_carpet" : "Nettoyer le tapis",
      "clean_drapes_and_curtains" : "Nettoyage de tentures et rideaux",
      "clean_upholstery" : "Nettoyage des tissus d'ameublement",
      "remove_pet_stains_and_odors" : "Suppression des taches et odeurs d'animaux",
      "after_school_care" : "Service de garde après l'école",
      "all_hours_daycare" : "Garderie ouverte à toute heure",
      "bilingual_daycare" : "Garderie bilingue",
      "child_care_other" : "Autre",
      "drop_in_daycare" : "Garderie sans rendez-vous",
      "full_time_daycare" : "Garderie à temps plein",
      "in_home_daycare" : "Garderie à domicile",
      "infant_programs" : "Programmes pour nourrissons",
      "part_time_daycare" : "Garderie à temps partiel",
      "pre_kindergarten_programs" : "Programmes d'éducation préscolaire",
      "preschool_programs" : "Programmes préscolaires",
      "school_age_programs" : "Programmes pour les enfants d'âge scolaire",
      "special_needs_daycare" : "Garderie pour enfants ayant des besoins spéciaux",
      "summer_daycare" : "Garderie d'été",
      "toddler_programs" : "Programmes pour les tout-petits",
      "weekend_daycare" : "Garderie de fin de semaine",
      "chiropractor_acupuncture" : "Acupuncture",
      "chiropractor_chiropractic" : "Chiropratique",
      "chiropractor_massage_therapy" : "Massothérapie",
      "chiropractor_other" : "Autre",
      "diagnosis" : "Diagnostic",
      "eastern_medicine" : "Médecine orientale",
      "exercise_counseling" : "Conseil en activité physique",
      "pain_management" : "Gestion de la douleur",
      "physical_therapy" : "Physiothérapie",
      "spinal_adjustments" : "Ajustements de la colonne vertébrale",
      "sports_medicine" : "Médecine du sport",
      "cleaner_other" : "Autre",
      "deep_clean" : "Nettoyage en profondeur",
      "moving_clean" : "Nettoyage de déménagement",
      "office_clean" : "Nettoyage de bureau",
      "standard_clean" : "Nettoyage standard",
      "assignment_of_contract" : "Cession de contrat",
      "business_transactions_contract_lawyer" : "Transactions commerciales",
      "commercial_contracts_contract_lawyer" : "Contrats commerciaux",
      "contract_dispute" : "Litige contractuel",
      "contract_lawyer_other" : "Autre",
      "contract_negotiation" : "Négociation de contrat",
      "contract_review" : "Révision de contrat",
      "employment_contracts_contract_lawyer" : "Contrats de travail",
      "franchise_agreements" : "Accords de franchise",
      "mergers_acquisitions_contract_lawyer" : "Fusions et acquisitions",
      "non_disclosure_agreements_contract_lawyer" : "Accords de non-divulgation",
      "partnership_agreements_contract_lawyer" : "Accords de partenariat",
      "power_of_attorney_contract_lawyer" : "Procuration",
      "security_agreements" : "Accords de sécurité",
      "warranties" : "Garanties",
      "bathroom_countertops" : "Comptoirs de salle de bain",
      "bathroom_wall_panels" : "Panneaux muraux de salle de bain",
      "countertop_design" : "Stylisme de comptoirs",
      "countertop_installation" : "Installation de comptoirs",
      "countertop_pro_other" : "Autre",
      "fireplace_facade" : "Façade de foyer",
      "granite_countertops" : "Comptoirs en granit",
      "kitchen_countertops" : "Comptoirs de cuisine",
      "kitchen_wall_panels" : "Panneaux muraux de cuisine",
      "laminate_countertops" : "Comptoirs en stratifié",
      "marble_countertops" : "Comptoirs en marbre",
      "quartz_countertops" : "Comptoirs en quartz",
      "remodeling_countertop_pro" : "Rénovation",
      "repair_maintenance_countertop_pro" : "Réparation et maintenance",
      "stone_slab_countertops" : "Comptoirs en dalles de pierre",
      "tile_countertops" : "Comptoirs en carreaux",
      "corporate_representation" : "Représentation d'entreprise",
      "criminal_immigration_defense" : "Défense criminelle en matière d'immigration",
      "criminal_lawyer_other" : "Autre",
      "domestic_violence" : "Violence conjugale",
      "drug_possession" : "Possession de drogue",
      "duis_reckless_driving" : "Conduite avec facultés affaiblies et conduite imprudente",
      "expungement" : "Radiation",
      "federal_crimes" : "Crimes fédéraux",
      "felonies" : "Crimes graves",
      "petty_crimes_misdemeanors" : "Délits et infractions mineurs",
      "restraining_orders" : "Ordonnances restrictives",
      "sex_offenses" : "Infractions sexuelles",
      "three_strikes_law" : "Loi des trois fautes",
      "dance_instructor_african" : "Africain",
      "dance_instructor_ballet" : "Danse classique",
      "dance_instructor_ballroom" : "Salle de bal",
      "dance_instructor_belly" : "Ventre",
      "dance_instructor_bollywood" : "Bollywood",
      "dance_instructor_contemporary" : "Danse contemporaine",
      "dance_instructor_folk_traditional" : "Folklorique et traditionnelle",
      "dance_instructor_hip_hop" : "Hip-hop",
      "dance_instructor_jazz" : "Jazz",
      "dance_instructor_kids_classes" : "Cours pour enfants",
      "dance_instructor_latin" : "Latine",
      "dance_instructor_modern" : "Moderne",
      "dance_instructor_other" : "Autre",
      "dance_instructor_tap" : "Claquettes",
      "dance_instructor_wedding" : "Mariage",
      "disability_hearings" : "Audiences sur l'invalidité",
      "disability_lawyer_other" : "Autre",
      "long_term_disability" : "Invalidité à long terme",
      "short_term_disability" : "Invalidité à court terme",
      "social_security_disability_insurance" : "Assurance invalidité de la sécurité sociale",
      "ssa_claim_reconsideration" : "Réexamen de la demande SSA",
      "ssa_disability_appeals" : "Appels d'invalidité de la SSA",
      "ssa_disability_applications" : "Applications d'invalidité SSA",
      "ssa_disability_benefits" : "Prestations d'invalidité de la SSA",
      "ssa_family_benefits" : "Prestations familiales SSA",
      "ssa_impairment_listings" : "Listes d'invalidité de la SSA",
      "supplemental_security_income" : "Supplemental Security Income",
      "veterans_disability_benefits" : "Prestations d'invalidité pour anciens combattants",
      "workers_compensation_disability_lawyer" : "Indemnisation des travailleurs",
      "behind_the_wheel_lessons" : "Leçons de conduite accompagnée",
      "commercial_license_training" : "Cours sur les permis commerciaux",
      "defensive_driving_lessons" : "Leçons de conduite défensive",
      "drivers_education_classes" : "Cours d'éducation à la conduite",
      "driving_instructor_other" : "Autre",
      "manual_transmission_lessons" : "Leçons sur la transmission manuelle",
      "motorcycle_lessons" : "Leçons de moto",
      "traffic_school" : "École de conduite",
      "dui_dwi_dui_lawyer" : "Conduite avec facultés affaiblies",
      "dui_injuries_dui_lawyer" : "Conduite avec facultés affaiblies avec blessure",
      "dui_lawyer_other" : "Autre",
      "dui_with_accident" : "Conduite avec facultés affaiblies avec accident",
      "felony_dui" : "Acte délictueux grave de conduite avec facultés affaiblies",
      "invalid_tests" : "Essais non valides",
      "multiple_offenses" : "Infractions multiples",
      "reckless_driving_dui_lawyer" : "Conduite imprudente",
      "underage_dui" : "Conduite avec facultés affaiblies pour mineurs",
      "electric_car_charger" : "Installation d'un chargeur pour voiture électrique",
      "electrician_other" : "Autre",
      "electrician_remodeling" : "Rénovation",
      "install_fan" : "Installation de ventilateurs",
      "install_ground_wire" : "Installation de fils de mise à la terre",
      "install_light_fixtures" : "Installation de luminaires",
      "install_outdoor_lighting" : "Installation de l'éclairage extérieur",
      "install_outlets_switches" : "Installation des prises ou des interrupteurs",
      "install_security_system" : "Installation de systèmes de sécurité",
      "relocate_outlets_switches" : "Déplacement des prises ou des interrupteurs",
      "repair_fan" : "Réparation de ventilateurs",
      "repair_light_fixtures" : "Réparation de luminaires",
      "repair_outlets_switches" : "Réparation des prises ou des interrupteurs",
      "repair_panel" : "Panneau de réparation",
      "replace_upgrade_panel" : "Remplacement ou mise à niveau de panneau",
      "restore_power" : "Rétablissement de l'alimentation",
      "energy_efficiency_pro_other" : "Autre",
      "charitable_giving" : "Dons de bienfaisance",
      "contests_litigation" : "Contestations/litiges",
      "deeds" : "Actes notariés",
      "estate_lawyer_other" : "Autre",
      "estate_planning_lawyer" : "Planification successorale",
      "guardianship_estate_lawyer" : "Tutelle",
      "medical_power_of_attorney" : "Procuration médicale",
      "power_of_attorney_estate_lawyer" : "Procuration",
      "probate_estate_lawyer" : "Avocat en droit successoral",
      "trusts" : "Fiducies",
      "wills" : "Testaments",
      "anniversary_planner" : "Anniversaire",
      "baby_shower_planner" : "Fête prénatale",
      "bar_and_bat_mitzvah_planner" : "Bar et Bat Mitzvah",
      "birthday_party" : "Fête d'anniversaire",
      "children_party" : "Fête des enfants",
      "corporate_and_conference_planner" : "Entreprises et conférences",
      "event_planner_other" : "Autre",
      "quinceanera_planner" : "Quinceanera (fête des 15 ans)",
      "religious_event" : "Événement religieux",
      "retirement_party" : "Fête de départ à la retraite",
      "school_event" : "Événement scolaire",
      "theme_party" : "Fête à thème",
      "wedding_and_engagement_planner" : "Mariage et fiançailles",
      "adoption" : "Adoption",
      "child_support" : "Pension alimentaire",
      "contested_divorce" : "Divorce contesté",
      "debt_division" : "Division de la dette",
      "family_lawyer_other" : "Autre",
      "guardianship_family_lawyer" : "Tutelle",
      "mediation_family_lawyer" : "Médiation",
      "modifications_of_orders" : "Modification des commandes",
      "parent_timesharing" : "Partage du temps parental",
      "paternity" : "Paternité",
      "prenuptial_postnuptial_agreements" : "Contrats prénuptiaux et accords matrimoniaux",
      "probate_family_lawyer" : "Succession",
      "property_divisions" : "Division de la propriété",
      "protective_orders_domestic_violence_issues" : "Ordonnances restrictives",
      "spousal_support_alimony" : "Soutien conjugal et pension alimentaire",
      "uncontested_divorce" : "Divorce non contesté",
      "custom_construction" : "Construction personnalisée",
      "fence_design" : "Stylisme de clôture",
      "fencing_other" : "Autre",
      "installation_fencing_pro" : "Installation de clôtures",
      "repairs_maintenance_fencing_pro" : "Réparations et entretien",
      "education_savings" : "Épargne-études",
      "estate_financial_planning" : "Planification successorale",
      "financial_planning" : "Planification financière",
      "financial_planning_other" : "Autre",
      "home_purchase" : "Achat de maison",
      "insurance" : "Assurance",
      "investment_advising" : "Conseil en investissement",
      "retirement_savings" : "Retraite",
      "tax_planning" : "Planification fiscale",
      "advanced_cardiac_life_support" : "Assistance vitale cardiaque avancée",
      "aed_defibrillator" : "DEA - Défibrillateur",
      "basic_life_support" : "Assistance vitale de base",
      "cpr" : "RCR",
      "first_aid" : "Premiers secours",
      "first_aid_trainer_other" : "Autre",
      "pediatric_advanced_life_support" : "Assistance vitale pédiatrique avancée",
      "pediatric_cpr_first_aid" : "RCR et premiers soins pédiatriques",
      "pet_cpr_first_aid" : "RCR et premiers soins pour animaux de compagnie",
      "wilderness_first_aid" : "Premiers soins en milieu sauvage",
      "baseboards" : "Plinthes",
      "carpet" : "Tapis",
      "flooring_other" : "Autre",
      "hardwood" : "Bois de feuillus",
      "installation_flooring_pro" : "Installation de planchers",
      "marble" : "Marbre",
      "polishing" : "Polissage de planchers",
      "refinishing" : "Rénovation de planchers",
      "repair_maintenance_flooring_pro" : "Réparation et entretien de planchers",
      "stair_flooring" : "Revêtement d'escalier",
      "tile" : "Tuile",
      "wood_floor_sanding" : "Ponçage de plancher de bois",
      "basement_waterproofing" : "Imperméabilisation du sous-sol",
      "crawl_spaces" : "Fondation à vide sanitaire",
      "foundation_drainage" : "Drainage des fondations",
      "foundation_installation" : "Installation de fondations",
      "foundation_pro_other" : "Autre",
      "foundation_raising" : "Relèvement de fondations",
      "repairs_maintenance_foundation_pro" : "Réparations et maintenance",
      "slab_foundation" : "Fondation en dalle",
      "steel_pier_pilings" : "Pieux en acier",
      "water_moisture_control" : "Contrôle de l'eau et de l'humidité",
      "burials" : "Inhumations",
      "caskets" : "Cercueils",
      "cremation" : "Crémation",
      "funeral_home_flowers" : "Fleurs",
      "funeral_home_other" : "Autre",
      "funeral_home_transportation_transfers" : "Transports et transferts",
      "funeral_home_veteran_services" : "Services aux anciens combattants",
      "funerals" : "Funérailles",
      "gravestones" : "Pierres tombales",
      "grief_services" : "Services de deuil",
      "memorials" : "Monuments commémoratifs",
      "urns" : "Urnes",
      "garage_door_other" : "Autre",
      "general_maintenance" : "Maintenance générale",
      "install_garage_door" : "Installation de portes de garage",
      "install_opener" : "Installation d'ouvre-porte",
      "repair_cables" : "Réparation de câbles",
      "repair_garage_door" : "Réparation de portes de garage",
      "repair_gate" : "Réparation de portails",
      "repair_rollers_tracks" : "Réparation des rouleaux et des rails",
      "replace_door_panels" : "Remplacer les panneaux de porte",
      "replace_opener" : "Remplacement d'ouvre-porte",
      "replace_springs" : "Remplacement des ressorts",
      "accessory_buildings" : "Bâtiments accessoires",
      "bathroom_remodel" : "Rénovation de salle de bain",
      "decks_patio" : "Terrasses et patio",
      "exterior_finishing" : "Finition extérieure",
      "foundations_concrete" : "Fondations et béton",
      "general_contractor_commercial_projects" : "Projets commerciaux",
      "general_contractor_other" : "Autre",
      "home_addition" : "Agrandissement résidentiel",
      "home_building" : "Construction résidentielle",
      "home_remodel_renovation" : "Remodelage et rénovation domiciliaire",
      "interior_finishing" : "Finition intérieure",
      "kitchen_remodel" : "Rénovation de cuisine",
      "roofing" : "Toiture",
      "assemble_furniture" : "Assembler des meubles",
      "clean_gutters" : "Nettoyage des gouttières",
      "handyman_other" : "Autre",
      "install_drywall" : "Installation de cloisons sèches",
      "install_flooring" : "Pose de planchers",
      "install_tile" : "Pose de carreaux",
      "install_water_fixtures" : "Installation d'appareils sanitaires",
      "mount_tv" : "Montage de téléviseurs",
      "paint_indoors" : "Peinture à l'intérieur",
      "paint_outdoors" : "Peinture à l'extérieur",
      "repair_drywall" : "Réparer les cloisons sèches",
      "repair_flooring" : "Réparer le plancher",
      "repair_water_fixtures" : "Réparation d'appareils sanitaires",
      "replace_tile" : "Remplacement de carreaux",
      "buyer_seller_inspection" : "Inspection acheteur/marchand",
      "commercial_properties" : "Propriétés commerciales",
      "fire_safety" : "Sécurité incendie",
      "fireplace_chimney" : "Foyer et cheminée",
      "full_home_inspection" : "Inspection complète de la maison",
      "home_inspector_electrical" : "Appareils électrique",
      "home_inspector_foundation" : "Fondations",
      "home_inspector_hvac" : "CVC",
      "home_inspector_mold" : "Moisissures",
      "home_inspector_new_construction" : "Nouvelle construction",
      "home_inspector_other" : "Autre",
      "home_inspector_plumbing" : "Plomberie",
      "home_inspector_roof" : "Toit",
      "home_inspector_structural" : "Structurel",
      "home_warranty" : "Garantie habitation",
      "water_testing" : "Analyse de l'eau",
      "well_or_septic_system" : "Puits ou système septique",
      "wood_insects" : "Bois et insectes",
      "access_control" : "Contrôle d'accès",
      "alarm_systems" : "Systèmes d'alarme",
      "commercial_security_systems" : "Systèmes de sécurité commerciaux",
      "fire_smoke_detection" : "Détection des incendies et des fumées",
      "home_security_doors" : "Portes",
      "home_security_locks" : "Verrous",
      "home_security_other" : "Autre",
      "home_security_windows" : "Fenêtres",
      "monitoring_services" : "Services de contrôle",
      "residential_security_systems" : "Systèmes de sécurité résidentiels",
      "smart_home_integration" : "Intégration de la maison intelligente",
      "video_surveillance" : "Surveillance vidéo",
      "audio_video_installation" : "Installation audio-vidéo",
      "commercial_projects" : "Projets commerciaux",
      "home_theater_design" : "Conception de cinéma à domicile",
      "home_theater_lighting" : "Éclairage",
      "home_theater_other" : "Autre",
      "home_theater_smart_home_integration" : "Intégration de la maison intelligente",
      "install_tv" : "Installation de téléviseurs",
      "network_it_services" : "Services réseau et informatique",
      "outdoor_installations" : "Installations extérieures",
      "soundproofing" : "Insonorisation",
      "whole_house_audio_video" : "Vidéo audio de toute la maison",
      "ac_maintenance" : "Entretien de la climatisation",
      "clean_ducts_vents" : "Nettoyage des conduits et des évents",
      "ductless_heating_and_ac_services" : "Services de chauffage et climatisation sans conduit",
      "heating_maintenance" : "Entretien du chauffage",
      "hvac_maintenance" : "Entretien CVC",
      "hvac_other" : "Autre",
      "install_ac" : "Installation de la climatisation",
      "install_ducts_vents" : "Installation des conduits et évents",
      "install_heating_system" : "Installer un système de chauffage",
      "install_thermostat" : "Installation de thermostats",
      "repair_ac" : "Réparation de la climatisation",
      "repair_ducts_vents" : "Réparation des conduits et évents",
      "repair_heating_system" : "Réparation des systèmes de chauffage",
      "repair_hvac" : "Réparation de CVC",
      "repair_thermostat" : "Réparer le thermostat",
      "asylum" : "Asile",
      "citizenship" : "Citoyenneté",
      "deportation" : "Expulsion",
      "family_based_immigration" : "Immigration familiale",
      "green_card" : "Carte verte",
      "immigration_lawyer_other" : "Autre",
      "investment_visa" : "Visa d'investissement",
      "outbound_work_permits" : "Permis de travail sortant",
      "student_visa" : "Visa étudiant",
      "visitor_visa" : "Visa de visiteur",
      "work_visa" : "Visa de travail",
      "appliance_selection" : "Sélection des appareils",
      "cabinetry_molding_hardware_design" : "Conception d'armoires et de quincaillerie",
      "decorating" : "Décoration",
      "door_design" : "Conception de portes",
      "exterior_building_design" : "Conception extérieure des bâtiments",
      "flooring_selection" : "Sélection de revêtements de sol",
      "interior_designer_other" : "Autre",
      "landscaping_design" : "Conception d'aménagement paysager",
      "lighting_design" : "Conception d'éclairage",
      "multifamily_housing_design" : "Conception de logements multifamiliaux",
      "room_planning" : "Planification des pièces",
      "stone_brick_stucco_design" : "Conception en pierre, brique et stuc",
      "window_design" : "Conception de fenêtres",
      "advertisements" : "Publicités",
      "copyright" : "Droit d'auteur",
      "export_control" : "Contrôle des exportations",
      "franchises" : "Franchises",
      "international_ip" : "IP international",
      "ip_lawyer_other" : "Autre",
      "ip_strategy" : "Forfait IP",
      "ip_transactions" : "Transactions IP",
      "licensing" : "Licences",
      "litigation_ip_lawyer" : "Litiges",
      "non_disclosure_agreements_ip_lawyer" : "Accords de non-divulgation",
      "patents" : "Brevets",
      "technology_transfer" : "Transfert de technologie",
      "trade_secrets" : "Secrets commerciaux",
      "trademarks" : "Marques de commerce",
      "appliance_removal" : "Enlèvement d'appareils",
      "construction_waste_removal" : "Enlèvement des déchets de construction",
      "donation_pickup" : "Ramassage des dons",
      "electronic_waste_removal" : "Enlèvement des déchets électroniques",
      "furniture_removal" : "Enlèvement de meubles",
      "general_junk_removal" : "Enlèvement général des déchets",
      "hazardous_waste_removal" : "Enlèvement des déchets dangereux",
      "house_garage_cleanout" : "Nettoyage de maison/garage",
      "junk_removal_other" : "Autre",
      "yard_waste_removal" : "Enlèvement des déchets de jardin",
      "employment_contracts_labor_lawyer" : "Contrats de travail",
      "employment_law_labor_lawyer" : "Droit du travail",
      "exempt_employee_status" : "Statut d'employé exempté",
      "labor_law" : "Droit du travail",
      "labor_lawyer_other" : "Autre",
      "labor_negotiations" : "Négociations syndicales",
      "privacy_rights" : "Droits à la vie privée",
      "sexual_harassment" : "Harcèlement sexuel",
      "unpaid_overtime" : "Heures supplémentaires non payées",
      "whistle_blowing" : "Lanceur d'alerte",
      "workers_compensation_labor_lawyer" : "Indemnisation des travailleurs",
      "wrongful_termination" : "Congédiement injustifié",
      "artificial_turf_installation" : "Installation de gazon synthétique",
      "concrete_masonry" : "Maçonnerie en béton",
      "driveway_landscaping" : "Aménagement paysager de l'entrée de garage",
      "garden_decorations" : "Décorations de jardin",
      "grading_resloping" : "Nivellement et réaménagement des pentes",
      "hardscapes" : "Aménagements à l'aide de matériaux inertes",
      "landscape_design" : "Aménagement paysager",
      "landscape_installations" : "Installations de terrain",
      "landscaper_other" : "Autre",
      "outdoor_steps" : "Marches extérieures",
      "outdoor_water_feature" : "Fontaines extérieures",
      "paving_driveway_walkway" : "Pavage d'entrée de garage ou d'allée",
      "retaining_walls" : "Murs de soutènement",
      "sidewalk_walkway_landscaping" : "Aménagement paysager de l'allée",
      "sod_seeding" : "Gazon et semis",
      "stone_masonry" : "Maçonnerie en pierre",
      "arabic" : "Arabe",
      "english" : "Anglais",
      "french" : "French",
      "german" : "Allemand",
      "hebrew" : "Hébreu",
      "italian" : "Italien",
      "japanese" : "Japonais",
      "korean" : "Coréen",
      "language_instructor_other" : "Autre",
      "mandarin" : "Mandarin",
      "portuguese" : "Portugais",
      "russian" : "Russe",
      "sign_language" : "Langue des signes",
      "spanish" : "Espagnol",
      "irrigation_system_repair_maintenance" : "Réparation/entretien du système d'irrigation",
      "lawn_care_other" : "Autre",
      "lawn_mowing_maintenance" : "Tonte/entretien de la pelouse",
      "lawn_pest_control" : "Lutte antiparasitaire sur pelouse",
      "mulching" : "Paillage",
      "seeding" : "Ensemencement",
      "sod_installation" : "Installation de gazon",
      "weed_control" : "Gestion des mauvaises herbes",
      "yard_cleanup" : "Nettoyage de la cour",
      "appeals" : "Appels",
      "case_assessment_litigation_lawyer" : "Évaluation de cas",
      "civil_litigation" : "Litige civil",
      "commercial_litigation" : "Litige commercial",
      "contracts_and_agreements" : "Contrats et accords",
      "criminal_litigation" : "Litigation criminelle",
      "litigation_lawyer_other" : "Autre",
      "mediation_litigation_lawyer" : "Médiation",
      "settlements" : "Règlements",
      "building_lockout" : "Verrouillage du bâtiment",
      "copy_building_key" : "Copie des clés de l'immeuble",
      "copy_vehicle_key" : "Copie de la clé du véhicule",
      "install_hardware" : "Installation de matériel",
      "locksmith_other" : "Autre",
      "new_key_fob" : "Nouveau porte-clés",
      "rekey_lock" : "Verrouillage de touche d'inversion",
      "repair_hardware" : "Réparer le matériel",
      "vehicle_lockout" : "Verrouillage de véhicule",
      "consent_issues" : "Problèmes de consentement",
      "diagnosis_errors" : "Erreurs de diagnostic",
      "malpractice_lawyer_other" : "Autre",
      "medical_negligence" : "Négligence médicale",
      "treatment_errors" : "Erreurs de traitement",
      "massage_center_other" : "Autre",
      "massage_school_advanced_neuromuscular_therapy" : "Thérapie neuromusculaire avancée",
      "massage_school_business_and_ethics" : "Entreprise et éthique",
      "massage_school_clinical_therapies" : "Thérapies cliniques",
      "massage_school_continuing_education" : "Éducation continue",
      "massage_school_deep_tissue_massage" : "Massage des tissus profonds",
      "massage_school_energetics" : "Énergétique",
      "massage_school_hydrotherapy" : "Hydrothérapie",
      "massage_school_lymphatic_massage" : "Massage lymphatique",
      "massage_school_online_massage_therapy" : "Thérapie de massage en ligne",
      "massage_school_other" : "Autre",
      "massage_school_prenatal_massage" : "Massage prénatal",
      "massage_school_sports_massage" : "Massage sportif",
      "massage_school_student_massage_clinic" : "Clinique de massage pour étudiants",
      "massage_school_swedish_massage" : "Massage suédois",
      "massage_theory" : "Théorie du massage",
      "massage_therapy_training" : "Cours de massothérapie",
      "in_state_move" : "Déménagement intraprovincial",
      "local_move" : "Déménagement local",
      "mover_other" : "Autre",
      "moving_junk_removal" : "Enlèvement des déchets",
      "moving_storage" : "Stockage",
      "out_of_state_move" : "Déménagement interprovincial",
      "oversized_item_move" : "Déménagement d'objets surdimensionnés",
      "packing_unpacking" : "Emballage / Déballage",
      "senior_move" : "Déménagement des aînés",
      "vehicle_transport" : "Transport de véhicules",
      "cardiac_care" : "Soins cardiaques",
      "general_medical_care" : "Soins médicaux généraux",
      "hospice" : "Hospice",
      "iv_therapy" : "Thérapie intraveineuse",
      "nursing_home_meal_services" : "Services de repas",
      "nursing_home_memory_care" : "Soins de la mémoire",
      "nursing_home_other" : "Autre",
      "nursing_home_pain_management" : "Gestion de la douleur",
      "nursing_home_rehabilitation_services" : "Services de réadaptation",
      "nursing_home_wellness_programs" : "Programmes de bien-être",
      "outpatient_rehabilitation" : "Réadaptation en consultation externe",
      "post_hospital_care" : "Soins post-hospitaliers",
      "respiratory_and_pulmonary_care" : "Soins respiratoires et pulmonaires",
      "senior_activity_programs" : "Programmes d'activités pour les aînés",
      "short_term_rehabilitation" : "Réhabilitation à court terme",
      "wound_care" : "Soins des plaies",
      "exterior_painting" : "Peinture extérieure",
      "interior_painting" : "Peinture d'intérieur",
      "paint_cabinets" : "Peindre des armoires",
      "paint_doors" : "Peindre les portes",
      "painter_other" : "Autre",
      "repair_water_damage" : "Réparation des dégâts des eaux",
      "staining" : "Coloration",
      "assault_battery" : "Agression et voies de fait",
      "auto_accidents" : "Accidents de voiture",
      "bicycle_accidents" : "Accidents de bicyclette",
      "catastrophic_injuries" : "Blessures catastrophiques",
      "dog_bites" : "Morsures de chien",
      "dui_injuries_personal_injury_lawyer" : "Blessures causées par une conduite avec facultés affaiblies",
      "medical_malpractice" : "Faute professionnelle médicale",
      "motorcycle_accidents" : "Accidents de moto",
      "pain_suffering" : "Douleur et souffrance",
      "pedestrian_accidents" : "Accidents de piétons",
      "personal_injury_lawyer_other" : "Autre",
      "product_liability" : "Responsabilité du produit",
      "slip_fall" : "Glissade et chute",
      "uninsured_motorist_claims" : "Réclamations d'assurance pour automobilistes",
      "workers_compensation_personal_injury_lawyer" : "Indemnisation des travailleurs",
      "wrongful_death" : "Décès préjudiciable",
      "aerobics" : "Aérobie",
      "athletic_performance" : "Performance athlétique",
      "circuit_training" : "Entraînement en circuit",
      "endurance" : "Endurance",
      "fitness_assessment" : "Évaluation de la condition physique",
      "hiit" : "HIIT",
      "nutritional_counseling" : "Conseils nutritionnels",
      "personal_trainer_other" : "Autre",
      "strength_conditioning" : "Entraînement de force et conditionnement",
      "weight_loss" : "Perte de poids",
      "yoga" : "Yoga",
      "ants" : "Fourmis",
      "bed_bugs" : "Punaises de lit",
      "bees" : "Abeilles",
      "cockroaches" : "Cafards",
      "fleas_or_mites" : "Puces ou acariens",
      "hornets_or_wasps" : "Frelons ou guêpes",
      "mosquitoes" : "Moustiques",
      "pest_control_other" : "Autre",
      "pest_inspection" : "Inspection",
      "rodents" : "Rongeurs",
      "spiders" : "Araignées",
      "termites" : "Termites",
      "wildlife" : "Faune",
      "pet_adoption_birds" : "Oiseaux",
      "pet_adoption_cats" : "Chats",
      "pet_adoption_dogs" : "Chiens",
      "pet_adoption_farm_animals" : "Animaux de ferme",
      "pet_adoption_fish" : "Poissons",
      "pet_adoption_other" : "Autre",
      "pet_adoption_reptiles" : "Reptiles",
      "pet_adoption_small_mammals" : "Petits mammifères",
      "pet_adoption_special_needs_animals" : "Animaux ayant des besoins spéciaux",
      "cat_boarding" : "Pension pour chats",
      "cat_grooming" : "Toilettage pour chats",
      "cat_sitting_in_home" : "Garde de chats (à domicile)",
      "dog_boarding" : "Pension pour chiens",
      "dog_boarding_with_training" : "Pension pour chiens avec dressage",
      "dog_daycare" : "Garderie pour chiens",
      "dog_grooming" : "Toilettage pour chiens",
      "dog_sitting_in_home" : "Garde de chien (à domicile)",
      "dog_training" : "Dressage pour chiens",
      "dog_walking" : "Promenade de chiens",
      "other_pet_boarding" : "Autres pensions pour animaux",
      "other_pet_daycare" : "Autre garderie pour animaux de compagnie",
      "other_pet_grooming" : "Autres soins de toilettage pour animaux de compagnie",
      "other_pet_sitting_in_home" : "Autres services de garde d'animaux (à domicile)",
      "pet_boarding_other" : "Autre",
      "cat_bathing" : "Bain pour chats",
      "cat_ear_cleaning" : "Nettoyage des oreilles de chat",
      "cat_grooming_and_styling" : "Toilettage et stylisme pour chats",
      "cat_nail_trimming" : "Taille des griffes de chat",
      "dog_anal_gland_expression" : "Expression de la glande anale chez le chien",
      "dog_bathing_and_blow_dry" : "Bain pour chien et séchage au sèche-cheveux",
      "dog_ear_cleaning" : "Nettoyage des oreilles de chien",
      "dog_flea_and_tick_treatment" : "Traitement contre les puces et les tiques chez le chien",
      "dog_full_service_grooming" : "Toilettage complet pour chiens",
      "dog_grooming_and_styling" : "Toilettage et stylisme pour chiens",
      "dog_nail_trimming" : "Coupe des griffes de chien",
      "dog_teeth_brushing" : "Nettoyage des dents de chien",
      "pet_grooming_other" : "Autre",
      "aggressive_dog_training" : "Dressage pour chiens agressifs",
      "behavior_modification" : "Modification du comportement",
      "obedience_training" : "Dressage à l'obéissance",
      "offleash_training" : "Dressage sans laisse",
      "pet_trainer_other" : "Autre",
      "puppy_training" : "Dressage des chiots",
      "service_animal_training" : "Dressage des animaux d'assistance",
      "sport_trick_training" : "Dressage sportif ou apprentissage de tours",
      "training_other_animals" : "Dressage pour autres animaux",
      "corporate_photo" : "Entreprises",
      "events_and_parties_photo" : "Événements et fêtes",
      "family_and_group_photo" : "Famille et groupe",
      "headshots_and_portraits" : "Portraits",
      "individual_photo" : "Individuels",
      "maternity_and_newborn_photo" : "Maternité et nouveau-né",
      "photographer_other" : "Autre",
      "product_photo" : "Produit",
      "real_estate_photo" : "Immobilier",
      "school_portraits" : "Portraits scolaires",
      "wedding_and_engagement_photo" : "Mariage et fiançailles",
      "find_leak" : "Découverte et réparation des fuites",
      "install_faucet" : "Installer le robinet",
      "install_garbage_disposal" : "Installation de broyeurs à déchets",
      "install_shower" : "Installer une douche",
      "install_toilet" : "Installation de toilettes",
      "install_water_heater" : "Installation de chauffe-eaux",
      "plumbing_other" : "Autre",
      "repair_faucet" : "Réparation de robinets",
      "repair_garbage_disposal" : "Réparation de l'élimination des déchets",
      "repair_outdoor_systems" : "Réparation des systèmes extérieurs",
      "repair_pipe" : "Réparation de la tuyauterie",
      "repair_sewer" : "Réparation des égouts",
      "repair_shower" : "Réparer la douche",
      "repair_toilet" : "Réparation des toilettes",
      "repair_water_heater" : "Réparation des chauffe-eaux",
      "unclog_drain" : "Déboucher le drain",
      "commercial_pool_cleaning_maintenance" : "Nettoyage et entretien de piscines commerciales",
      "equipment_maintenance_repair" : "Réparation et entretien d'équipement",
      "one_time_pool_cleaning" : "Nettoyage de piscines une seule fois",
      "ongoing_pool_cleaning" : "Nettoyage régulier de piscines",
      "pool_cleaner_other" : "Autre",
      "pool_cleaner_water_features" : "Fontaines",
      "seasonal_opening_closing" : "Ouverture et fermeture saisonnières",
      "spa_hot_tub_cleaning" : "Nettoyage de spas et de bains à remous",
      "spa_hot_tub_repairs" : "Réparations de spas et de bains à remous",
      "tile_pool_wall_cleaning" : "Nettoyage de carreaux et de parois de piscines",
      "water_testing_balancing" : "Tests et équilibrage de l'eau",
      "jetted_lap_pools" : "Piscine à débordement avec bain à remous",
      "pool_construction" : "Construction de piscines",
      "pool_contractor_commercial_projects" : "Projets commerciaux",
      "pool_contractor_custom_designs" : "Stylismes personnalisés",
      "pool_contractor_other" : "Autre",
      "pool_contractor_renovation" : "Rénovation",
      "pool_contractor_repair_cracks" : "Réparer les fissures",
      "pool_contractor_repair_tile" : "Réparation de carreaux",
      "pool_contractor_resurfacing" : "Resurfaçage",
      "pool_contractor_water_features" : "Fontaines",
      "pool_hot_tub_equipment" : "Équipement pour piscines et spas",
      "spa_hot_tub_installation" : "Installation de spas et de bains à remous",
      "bilingual_programs" : "Programmes bilingues",
      "early_preschool" : "Préscolaire précoce",
      "full_day_preschool" : "Prématernelle à temps plein",
      "half_day_preschool" : "École maternelle d'une demi-journée",
      "kindergarten_classes" : "Cours de maternelle",
      "montessori_programs" : "Programmes Montessori",
      "play_based_preschool" : "Prématernelle axée sur le jeu",
      "preschool_infant_programs" : "Programmes pour nourrissons",
      "preschool_other" : "Autre",
      "reggio_emilia_preschool" : "École maternelle Reggio Emilia",
      "special_needs_programs" : "Programmes pour besoins spéciaux",
      "summer_camp" : "Camp d'été",
      "waldorf_preschool" : "École maternelle Waldorf",
      "psychologist_other" : "Autre",
      "buyer_agent" : "Agent de l'acheteur",
      "first_time_home_buyer" : "Primo-acquéreur de maison",
      "foreclosed_properties" : "Propriétés saisies",
      "luxury_properties" : "Propriétés de luxe",
      "new_construction" : "Nouvelle construction",
      "property_management" : "Gestion de propriétés",
      "real_estate_agent_other" : "Autre",
      "relocation" : "Déménagement",
      "rentals" : "Locations",
      "sellers_agent" : "Agent du vendeur",
      "commercial_real_estate" : "Immobilier commercial",
      "easements" : "Servitudes",
      "encroachment" : "Empiétement",
      "foreclosure_real_esate_lawyer" : "Saisie immobilière",
      "landlord_tenant_law" : "Droit du propriétaire et du locataire",
      "litigation_real_estate_lawyer" : "Litiges",
      "mortgage_lending_law" : "Droit des hypothèques et des prêts",
      "neighbor_hoa_disputes" : "Différends entre voisins et associations de propriétaires",
      "property_damage" : "Dommages matériels",
      "purchase_agreements" : "Contrats d'achat",
      "real_estate_contracts_transactions" : "Transactions immobilières",
      "real_estate_lawyer_other" : "Autre",
      "residential_real_estate" : "Immobilier résidentiel",
      "title_services" : "Services d'enregistrement",
      "trespassing" : "Intrusion",
      "rehab_other" : "Autre",
      "attic_venting" : "Ventilation du grenier",
      "gutter_installation" : "Installation de gouttières",
      "gutter_repair" : "Réparation de gouttières",
      "roof_inspection" : "Inspection de toiture",
      "roof_installation" : "Installation de toiture",
      "roof_repair" : "Réparation de toiture",
      "roofer_other" : "Autre",
      "skylight_installation" : "Installation de puits de lumière",
      "skylight_repair" : "Réparation de puits de lumière",
      "storm_wind_damage_roof_repair" : "Réparation des dommages au toit",
      "sewage_cleaning" : "Nettoyage",
      "sewage_excavation" : "Travaux de terrassement",
      "sewage_inspection" : "Inspection",
      "sewage_installation" : "Installation",
      "sewage_locating" : "Localisation",
      "sewage_maintenance_repairs" : "Entretien et réparations",
      "sewage_pro_other" : "Autre",
      "sewage_pumping" : "Pompage",
      "sewage_removal_demolition" : "Enlèvement ou démolition",
      "remodeling_siding_pro" : "Rénovation",
      "repair_maintenance_siding_pro" : "Réparation et entretien",
      "siding_installation" : "Installation de revêtement",
      "siding_pro_other" : "Autre",
      "siding_removal" : "Enlèvement de revêtements",
      "smart_home_other" : "Autre",
      "commercial_snow_removal" : "Déneigement commercial",
      "residential_plowing" : "Déneigement résidentiel",
      "residential_shoveling_blowing" : "Déblaiement et soufflage des neiges résidentiels",
      "salt_sand_deicing" : "Sel, sable et déglaçage",
      "snow_relocation" : "Déneigement",
      "snow_removal_other" : "Autre",
      "body_polish" : "Exfoliation du corps",
      "body_wrap" : "Enveloppe corporelle",
      "facial" : "Visage",
      "hydrotherapy" : "Hydrothérapie",
      "manicure" : "Manucure",
      "massage" : "Massage",
      "pedicure" : "Pédicure",
      "peels" : "Exfoliation",
      "spa_other" : "Autre",
      "spa_packages" : "Offres spa",
      "tanning" : "Bronzage",
      "waxing" : "Épilation à la cire",
      "civil_tax_litigation" : "Litiges fiscaux civils",
      "corporate_taxes" : "Taxes sur les sociétés",
      "criminal_tax_litigation" : "Litiges fiscaux criminels",
      "estate_tax_planning" : "Planification de l'impôt sur les successions",
      "failure_to_file" : "Défaut de dépôt",
      "innocent_spouse_relief" : "Allégement pour époux non fautif",
      "international_tax_services" : "Services des taxes internationales",
      "irs_tax_problems" : "Problèmes fiscaux avec l'IRS",
      "non_collectible_status" : "Réputation de non-recouvrabilité",
      "offer_in_compromise" : "Offre de règlement amiable",
      "tax_audits" : "Vérifications fiscales",
      "tax_lawyer_other" : "Autre",
      "tax_liens_levies" : "Privilèges et prélèvements fiscaux",
      "tax_planning_lawyer" : "Planification fiscale",
      "tax_relief" : "Allègement fiscal",
      "accounting_support" : "Soutien comptable",
      "business_incorporation_restructuring" : "Incorporation et Restructuration",
      "cryptocurrency_taxes" : "Taxes sur les cryptomonnaies",
      "irs_audit_representation" : "Représentation pour l'audit de l'IRS",
      "irs_filing" : "Dépôt auprès de l'IRS",
      "irs_problem_consulting" : "Consultation sur les problèmes liés à l'IRS",
      "new_business_services" : "Services aux nouvelles entreprises",
      "payroll_support" : "Soutien à la paie",
      "tax_planning_tax_specialist" : "Planification fiscale",
      "tax_preparation" : "Préparation fiscale",
      "tax_problem_consulting_tax_specialist" : "Consultation pour les problèmes fiscaux",
      "tax_specialist_other" : "Autre",
      "therapist_other" : "Autre",
      "battery_service" : "Service de batterie",
      "car_towing" : "Remorquage de voitures",
      "fuel_delivery" : "Livraison de carburant",
      "local_hauling" : "Transport local",
      "long_distance_hauling" : "Transport longue distance",
      "motorcycle_towing" : "Remorquage de motos",
      "special_vehicle_towing" : "Remorquage de véhicules spéciaux",
      "tire_change" : "Changement de pneus",
      "towing_other" : "Autre",
      "case_assessment_traffic_lawyer" : "Évaluation de cas",
      "cdl_traffic_ticket" : "Contravention pour permis de conduire commercial (CDL)",
      "dui_dwi_traffic_lawyer" : "Conduite avec facultés affaiblies",
      "fixit_ticket" : "Contravention pour défaut de réparation",
      "parking_ticket" : "Contravention pour stationnement",
      "reckless_driving_traffic_lawyer" : "Conduite imprudente",
      "red_light_ticket" : "Contravention pour feu rouge",
      "speeding_ticket" : "Contravention pour excès de vitesse",
      "suspended_license" : "Suspension de permis",
      "traffic_lawyer_other" : "Autre",
      "traffic_ticket" : "Contravention de circulation",
      "cabling_and_bracing" : "Câblage et attaches",
      "stump_removal" : "Enlèvement des souches",
      "tree_planting" : "Plantation d’arbres",
      "tree_removal" : "Enlèvement des arbres",
      "tree_service_other" : "Autre",
      "tree_transplanting" : "Transplantation d’arbres",
      "tree_trimming_and_pruning" : "Taille et élagage des arbres",
      "tutor_computer_science" : "Informatique",
      "tutor_foreign_languages" : "Langues étrangères",
      "tutor_geography" : "Géographie",
      "tutor_government_and_economics" : "Gouvernement et Économie",
      "tutor_history" : "Histoire",
      "tutor_homework_help" : "Aide aux devoirs",
      "tutor_math" : "Mathématiques",
      "tutor_other" : "Autre",
      "tutor_reading_and_writing" : "Lecture et écriture",
      "tutor_science" : "Science",
      "tutor_special_education" : "Éducation spécialisée",
      "tutor_test_pre_college_entrance" : "Préparation aux examens : entrée au collège",
      "tutor_test_prep_grad_school_entrance" : "Préparation aux examens : entrée à l'école supérieure",
      "tutor_test_prep_k8" : "Préparation aux examens : de la maternelle à la 8e année",
      "area_rug_cleaning" : "Nettoyage de carpettes",
      "drapery_and_blind_cleaning" : "Nettoyage de rideaux et de stores",
      "leather_cleaning" : "Nettoyage du cuir",
      "mattress_cleaning" : "Nettoyage de matelas",
      "upholstery_cleaner_other" : "Autre",
      "upholstery_cleaning" : "Nettoyage de tissus d'ameublement",
      "upholstery_water_damage_cleanup" : "Nettoyage des dégâts des eaux",
      "bird_exotic_animal_care" : "Soins aux oiseaux et aux animaux exotiques",
      "farm_barn_animal_care" : "Soin des animaux de ferme et d'étable",
      "microchipping" : "Micropuçage",
      "veterinarian_allergies" : "Allergies",
      "veterinarian_behavior_counseling" : "Conseils comportementaux",
      "veterinarian_dental_care" : "Soins dentaires",
      "veterinarian_dermatology" : "Dermatologie",
      "veterinarian_emergency_care" : "Soins d’urgence",
      "veterinarian_end_of_life_care" : "Soins de fin de vie",
      "veterinarian_examinations" : "Examens",
      "veterinarian_nutrition_counseling" : "Conseils en nutrition",
      "veterinarian_other" : "Autre",
      "veterinarian_preventive_care" : "Soins préventifs",
      "veterinarian_spay_neuter" : "Stérilisation ou castration",
      "veterinarian_surgery" : "Chirurgie",
      "veterinarian_vaccinations" : "Vaccinations",
      "aerial_videography" : "Vidéographie aérienne",
      "documentary_video_production" : "Production de documentaires",
      "family_video_production" : "Production de vidéos familiales",
      "live_streaming" : "Diffusion en direct",
      "photography" : "Photographie",
      "product_demonstrations" : "Démonstration de produit",
      "promotional_video_production" : "Production de vidéos promotionnelles",
      "real_estate_video_production" : "Production de vidéos immobilières",
      "special_event_video_production" : "Production de vidéos pour événements spéciaux",
      "video_editing" : "Montage vidéo",
      "videographer_other" : "Autre",
      "voice_overs" : "Voix off",
      "wedding_video_production" : "Production de vidéos de mariage",
      "fire_damage_cleanup_repair" : "Nettoyage/réparation des dommages causés par le feu",
      "water_damage_cleanup_repair" : "Nettoyage des dégâts des eaux",
      "water_damage_flooring" : "Revêtement de sol",
      "water_damage_mold_inspection" : "Inspection des moisissures",
      "water_damage_mold_removal" : "Élimination de la moisissure",
      "water_damage_other" : "Autre",
      "water_damage_painting" : "Peinture",
      "water_damage_pest_control" : "Contrôle des nuisibles",
      "water_damage_plumbing" : "Plomberie",
      "water_damage_remodeling" : "Rénovation",
      "water_damage_roofing" : "Toiture",
      "water_damage_sewage_cleanup" : "Nettoyage des eaux usées",
      "adult_weight_loss_programs" : "Programmes de perte de poids pour adultes",
      "diet_and_nutrition_counseling" : "Conseils en diététique et nutrition",
      "kids_weight_loss_programs" : "Programmes de perte de poids pour enfants",
      "metabolic_testing" : "Tests métaboliques",
      "weight_loss_consultation_and_training" : "Consultation et formation",
      "weight_loss_fitness_programs" : "Programmes de conditionnement physique",
      "weight_loss_meal_planning" : "Planification des repas",
      "weight_loss_personal_training" : "Entraînement personnel",
      "weight_loss_service_other" : "Autre",
      "weight_loss_wellness_programs" : "Programmes de bien-être",
      "glass_and_mirror_cleaning" : "Nettoyage du verre et des miroirs",
      "gutter_cleaning" : "Nettoyage des gouttières",
      "power_pressure_washing" : "Lavage à haute pression",
      "rooftop_skylight_cleaning" : "Nettoyage de toitures/puits de lumière",
      "window_cleaner_other" : "Autre",
      "window_cleaning" : "Nettoyage de fenêtres",
      "door_installation" : "Installation de portes",
      "door_repair" : "Réparation de porte",
      "glass_installation" : "Installation de verre",
      "window_boardup" : "Condamnation",
      "window_installation" : "Installation de fenêtres",
      "window_repair" : "Réparation de fenêtres",
      "window_repair_other" : "Autre",
      "install_new_wiper_blades" : "Installation de nouveaux balais d’essuie-glace",
      "repair_power_window" : "Réparation de fenêtres électriques",
      "repair_water_leak" : "Réparation de fuites d'eau",
      "repair_windshield" : "Réparation de pare-brises",
      "replace_rear_window" : "Remplacement de vitres arrières",
      "replace_side_view_mirrors" : "Réparation de rétroviseurs latéraux",
      "replace_side_window" : "Remplacement de vitres latérales",
      "replace_sunroof" : "Remplacement du verre de toits ouvrants",
      "replace_windshield" : "Remplacement de pare-brises",
      "windshield_other" : "Autre",
      "ashtanga" : "Ashtanga",
      "hatha" : "Hatha",
      "hot_yoga" : "Yoga chaud",
      "iyengar" : "Iyengar",
      "kundalini" : "Kundalini",
      "meditation" : "Méditation",
      "power_yoga" : "Yoga de l'énergie",
      "restorative" : "De rétablissement",
      "vinyasa" : "Vinyasa",
      "yin" : "Yin",
      "yoga_instructor_other" : "Autre"
    }
  }
}
